import { Avatar, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Grid2, MenuItem, Modal, Select, Snackbar, Tab, Tabs, TextField, Typography } from "@mui/material";
import React, { useEffect, useMemo, useRef, useState } from "react";
import mapPin from '../../assets/icons/LocationPin.svg';
import pickupMarker from '../../assets/icons/PickupIcon.svg';
import dropMarker from '../../assets/icons/DropIcon.svg';
import { DirectionsRenderer, GoogleMap, Marker, useJsApiLoader, Polyline ,HeatmapLayer} from "@react-google-maps/api";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import {makeGetRequestToUrl, makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import routeMarker from '../../assets/images/routeMarker.svg';
import yellowRouteMarker from '../../assets/images/yellowRouteMarker.svg';
import greyRouteMarker from '../../assets/images/greyRouteMarker.svg';
import mapVehicleICon from '../../assets/icons/mapvehicleicon.svg';
import vehicleTypeCar from '../../assets/images/vehicleTypeCar.svg';
import vehicletypeAuto from '../../assets/images/vehicletypeAuto.svg';
import vehicleTypeBike from '../../assets/images/vehicleTypeBike.svg';
import pickupIcon from '../../assets/icons/PickupIcon.svg';
import dropIcon from '../../assets/icons/DropIcon.svg';
import shuttleImg from '../../assets/icons/shuttleImg.svg';
import connectAddress from '../../assets/images/connectAddress.svg';
import { useNavigate } from "react-router-dom";
import PersonIcon from '@mui/icons-material/Person';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CarDriver from '../../assets/images/CabDriver.svg';
import { useGoogleMapsLoader } from "../../utils/GoogleMapsLoader";
import { useLocation } from "react-router-dom";
import CarIcon from "../../assets/icons/Car.svg";
import AutoIcon from '../../assets/icons/Auto.svg';
import BikeIcon from '../../assets/icons/Bike.svg';
import { Label } from "flowbite-react";
// import constants from '../../constant.js';

var constants = require('../../constant');

const styles = {
    errorBox: {
      backgroundColor: '#EFFBF7',
      color: '#0DBA78',
      border: '1px solid #0DBA78',
      paddingLeft: '10%',
      paddingRight: '10%',
      borderRadius: '5px',
      marginTop: '6px'
    }
};
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: '12px',
    textAlign: 'center'
};

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
      </div>
    );
}

function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
}

const MapView = () => {
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const autosUrl = config.autosUrl;
    const token = localStorage.getItem('token');
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [city, setCity] = useState(cities[0]);
    const [statusFilter, setStatusFilter] = useState(1);
    const [gpsStatusFilter, setGpsStatusFilter] = useState('');
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const queryEngagementId = params.get("engagement_id"); 
    const queryCityId = params.get("city_id");
    const [cityFilter, setCityFilter] = useState(() => {return queryCityId || cities[0]?.city_id;});
    const [debtLimit, setDebtLimit] = useState(cities[0]?.driver_debt_limit);

    const is_driver_debt_limit_enabled = localStorage.getItem('is_driver_debt_limit_enabled') || 0;

    const handleCityChange = (e) =>{
        const city =  cities.find((cityObj) => cityObj.city_id === e)
    }
    const [pickupLocation, setPickupLocation] = useState('');
    const [pickupLatLng, setPickupLatLng] = useState(null);

    const cityGeo = city ? city.geofence[0] : '';
    const geocenter = {
        lat: cityGeo ? cityGeo.reduce((sum, point) => sum + point.x, 0) / cityGeo.length : 0,
        lng: cityGeo ? cityGeo.reduce((sum, point) => sum + point.y, 0) / cityGeo.length : 0,
    };
    
    const [dropLocation, setDropLocation] = useState('');
    const [dropLatLng, setDropLatLng] = useState(null);

    const inputRef = useRef(null);   //pickup
    const inputDropRef = useRef(null);

    const [mapViewData, setMapViewData] = useState([]);
    const [allMapViewData, setAllMapViewData] = useState([]);
    const clientDemoType = localStorage.getItem('clientDemoType');
    const show_map_view_cancel_button = localStorage.getItem('show_map_view_cancel_button');
    const hide_fare_on_map_view_cancel = localStorage.getItem('hide_fare_on_map_view_cancel');

    const [directions, setDirections] = useState(null);
    const [pickupAddress, setPickupAddress] = useState('');
    const [dropAddress, setDropAddress] = useState('');
    const [rideDistance, setRideDistance] = useState(0);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [rideEndCheck, setRideEndCheck] = useState(false);
    const [endDriverLocation, setEndDriverLocation] = useState(false);
    const [selectedGrid, setSelectedGrid] = useState(null);
    const [value, setValue] = React.useState(0);
    const [gridClickData, setGridClickData] = useState(null);
    const [center,setCenter] = useState(geocenter);
    const [mapLoaded, setMapLoaded] = useState(false);
    const [clientDemoFilter, setClientDemoFilter] = useState(clientDemoType==1 ? 1 : 2);
    const [initialcityCenter,setInitialcityCenter] = useState();

    const [selectedShuttleGrid, setSelectedShuttleGrid] = useState(null);
    const [gridShuttleClickData, setGridShuttleClickData] = useState(null);
    const [shuttlePickupLatLng, setShuttlePickupLatLng] = useState(null);
    const [shuttleDropLatLng, setShuttleDropLatLng] = useState(null);
    const [showShuttleRoute, setShowShuttleRoute] = useState(false);
    const [greyPath, setGreyPath] = useState([]);
    const [bluePath, setBluePath] = useState([]);
    const [currentBluePolyline, setCurrentBluePolyline] = useState(null);
    const [currentGreyPolyline, setCurrentGreyPolyline] = useState(null);
    const [driverPhoneFilter, setDriverPhoneFilter] = useState('');
    const [driverEngagementIdFilter, setDriverEngagementIdFilter] = useState('');
    const [clientIdFilter, setclientIdFilter] = useState('');
    const [openReassign, setOpenReassign] = useState(false);
    const [reassignDriversData, setReassignDriversData] = useState([]);
    const [currentSessionId, setCurrentSessionId] = useState(null);
    const [selectedReassignDriver, setSelectedReassignDriver] = useState('');
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [openEndRideModal, setOpenEndRideModal] = useState(false);
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [selectedRouteId, setSelectedRouteId] = useState('');
    const taxi_show_mark_arrived_button = localStorage.getItem('taxi_show_mark_arrived_button');
    const taxi_show_start_ride_button = localStorage.getItem('taxi_show_start_ride_button');
    const taxi_show_end_ride_button = localStorage.getItem('taxi_show_end_ride_button');
    const taxi_show_reassign_ride_button = localStorage.getItem('taxi_show_reassign_ride_button');
    const taxi_show_mark_arrived_button_for_stops = localStorage.getItem('taxi_show_mark_arrived_button_for_stops');
    const show_driver_gps_status = localStorage.getItem('show_driver_gps_status');
    const SHUTTLE_TRACK_POLL_INTERVAL = 5000; // 10 seconds in milliseconds
    const [currentLatLng, setCurrentLatLng] = useState(null);
    const [previousLatLng, setPreviousLatLng] = useState(null);
    const [tempLatLng, setTempLatLng] = useState(null);
    const [shuttleMarker, setShuttleMarker] = useState(null); 
    const [animatedLatLng, setAnimatedLatLng] = useState(null);
    const [fullMapViewData, setFullMapViewData] = useState([]);
    const [heatMapData, setHeatMapData] = useState();
    const [gridClidDriverID, setGridClidDriverID] = useState(null);
    const [gridClickedVehcileType, setGridClickedVehcileType] = useState(null);
    const [taxiMapRef, setTaxiMapRef] = useState(null); 
    const [taxiCurrentLatLng, setTaxiCurrentLatLng] = useState(null);
    const [taxiPreviousLatLng, setTaxiPreviousLatLng] = useState(null);
    const [taxiMarker, setTaxiMarker] = useState(null);
    const followTaxiRef = useRef(true);

    const [ongoingRideCheck, setOngoingRideCheck] = useState(false);
    const [ongoingRideCheckMessage, setOngoingRideCheckMessage] = useState('');
    const [openTaxiCancelRide, setOpenTaxiCancelRide] = useState(false);
    const [cancelRideReason, setCancelRideReason] = useState('');
    const [refundPercentage, setRefundPercentage] = useState('');
    const utcoffset = localStorage.getItem('utc_offset') || '330';
    const [filter, setFilter] = useState('pickupTime');
    const client_id = localStorage.getItem('clientId');
    const admin_id = Number(localStorage.getItem('admin_id'));

    // Memoized filtered data based on driver phone filter
    const filteredMapViewData = React.useMemo(() => {
        let filteredData = [...mapViewData];

        // First filter by phone if filter is provided
        if (driverPhoneFilter) {
            filteredData = filteredData.filter(marker => {
                const phone = marker.driver_info?.driver_phone_number || 
                            marker.driver_details?.driver_phone_number || '';
                return phone.toString().toLowerCase().includes(driverPhoneFilter.toLowerCase());
            });
        }

        // Then filter by engagement ID if filter is provided
        if (driverEngagementIdFilter) {
            filteredData = filteredData.filter(marker => {
                const engagementId = marker.driver_info?.driver_engagement_id || 
                                marker.driver_details?.driver_engagement_id || 
                                marker.engagement_details?.engagement_id || '';
                return engagementId.toString().toLowerCase().includes(driverEngagementIdFilter.toLowerCase());
            });
        }

        if(clientIdFilter){
            filteredData = filteredData.filter(marker =>{
            const user_code = marker.client_details?.user_code || 
                            marker.user_details?.user_code || 
                            marker.user_code || 
                            marker.engagement_details?.user_code || '';

            return user_code.toString().toLowerCase().includes(clientIdFilter.toLowerCase());
         })
        }

        if (statusFilter && statusFilter != '1') {
            filteredData = filteredData.filter(marker => {
                const status = marker.engagement_details?.status || marker.trip_details?.status || '';
                return status.toString() === statusFilter;
            });
        }

        if (gpsStatusFilter !== '') {
            filteredData = filteredData.filter(marker => {
                const gpsStatus =
                    marker.driver_info?.gps_status // add any other real key
                return gpsStatus != null && String(gpsStatus) === String(gpsStatusFilter);
            });
        }

        if (filter === 'pickupTime') {
            filteredData.sort((a, b) => {
                const timeA = a.engagement_details?.pickup_time || a.trip_details?.pickup_time || '';
                const timeB = b.engagement_details?.pickup_time || b.trip_details?.pickup_time || '';
                return new Date(timeA) - new Date(timeB);
        });
        } else if (filter === 'engagementId') {
            filteredData.sort((a, b) => {
                const idA = a.engagement_details?.engagement_id || a.driver_info?.driver_engagement_id || '';
                const idB = b.engagement_details?.engagement_id || b.driver_info?.driver_engagement_id || '';
                return idA.toString().localeCompare(idB.toString());
            });
        }

        return filteredData;
    }, [mapViewData, driverPhoneFilter, driverEngagementIdFilter,statusFilter,clientIdFilter,gpsStatusFilter]);


    const mapRef = useRef(null); // Reference to the Google Map instance
    const directionsRendererRef = useRef(null); // Reference to the DirectionsRenderer instance

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const handleFilterChange = (filterType, value) => {
        if (filterType === 'city') setCityFilter(value);
        const city =  cities.find((cityObj) => cityObj.city_id === value)
        setCity(city);
        setDebtLimit(city.driver_debt_limit);
        const geoo = city ? city.geofence[0] : '';
        const geocenter = {
            lat: geoo ? geoo.reduce((sum, point) => sum + point.x, 0) / geoo.length : 0,
            lng: geoo ? geoo.reduce((sum, point) => sum + point.y, 0) / geoo.length : 0,
        };
        setCenter(geocenter);
    };

    const getHeatmapData = (data) => {
        return data.map((point) => {
          return new window.google.maps.LatLng(point.latitude, point.longitude);
        });
      };

    const navigate = useNavigate();

    // const loaderOptions = {
    //     id: 'google-map-script',
    //     googleMapsApiKey: constants.API_KEY, // Replace with your actual API key
    //     libraries: LIBRARIES,
    // }

    const allRoutes = useMemo(() => {
        const routeMap = new Map();
    
        fullMapViewData.forEach(routeObj => {
            const route = routeObj?.trip_details;
            if (route?.route_id && !routeMap.has(route.route_id)) {
                routeMap.set(route.route_id, {
                    route_id: route.route_id,
                    route_name: route.route_name || "Unnamed Route"
                });
            }
        });
    
        return Array.from(routeMap.values());
    }, [fullMapViewData]);
    
    
    const { isLoaded, loadError } = useGoogleMapsLoader();
    const [map, setMap] = useState(null)

    const containerStyle = {
        width: '100%',
        height: 'calc(100vh - 410px)',
    };
    const containerStyleMain = {
        width: '100%',
        height: 'calc(100vh - 220px)',
    }

    useEffect(()=>{
        if(gridClickData){

            const pickupLat = Number(gridClickData.engagement_details?.pickup_latitude) || 0;
            const pickupLng = Number(gridClickData.engagement_details?.pickup_longitude) || 0;
            const dropLat = Number(gridClickData.engagement_details?.drop_latitude) || 0;
            const dropLng = Number(gridClickData.engagement_details?.drop_longitude) || 0;

            const center = {
                lat: (pickupLat + dropLat) / 2,
                lng: (pickupLng + dropLng) / 2,
            };
            setCenter(center);
        }
        
    }, [gridClickData])

      
    useEffect(()=>{
        if(gridShuttleClickData){
            if (gridShuttleClickData?.trip_details?.route_details?.length > 0) {
                const bounds = new window.google.maps.LatLngBounds();
                
                // Add all points to bounds
                gridShuttleClickData?.trip_details.route_details.forEach(stop => {
                    bounds.extend({
                        lat: Number(stop.latitude),
                        lng: Number(stop.longitude)
                    });
                });
                
                // Set center to first stop
                const center = {
                    lat: Number(gridShuttleClickData?.trip_details.route_details[0].latitude),
                    lng: Number(gridShuttleClickData?.trip_details.route_details[0].longitude)
                };
                
                setCenter(center);
                setShowShuttleRoute(true); // Show the route when data is available
                
                // If map ref is available, fit bounds
                if (mapRef.current) {
                    mapRef.current.fitBounds(bounds);
                }
            }
        } else {
            setShowShuttleRoute(false); // Hide the route when no data
        }
    }, [gridShuttleClickData]);

    useEffect(()=>{
        if(gridShuttleClickData){
            const pickupLat = Number(gridShuttleClickData?.trip_details?.pickup_stop_latitude) || 0;
            const pickupLng = Number(gridShuttleClickData?.trip_details?.pickup_stop_longitude) || 0;
            const dropLat = Number(gridShuttleClickData?.trip_details?.drop_stop_latitude) || 0;
            const dropLng = Number(gridShuttleClickData?.trip_details?.drop_stop_longitude) || 0;

            const center = {
                lat: (pickupLat + dropLat) / 2,
                lng: (pickupLng + dropLng) / 2,
            };
            setCenter(center);
        }
        
    }, [gridShuttleClickData])

    useEffect(() => {
        // Reset grid data when filter changes
        setGridClickData(null);
        setGridShuttleClickData(null);
        setShowShuttleRoute(false);

        // Reset map view if needed
        if (mapRef.current) {
            // Set default center and zoom
            // const defaultCenter = {
            //     lat: mapViewData && mapViewData.length > 0
            //         ? mapViewData.reduce((sum, point) => sum + parseFloat(point.driver_details?.driver_current_latitude || 0), 0) / mapViewData.length
            //         : 28.4595, // Default to Delhi NCR if no data
            //     lng: mapViewData && mapViewData.length > 0
            //         ? mapViewData.reduce((sum, point) => sum + parseFloat(point.driver_details?.driver_current_longitude || 0), 0) / mapViewData.length
            //         : 77.0266
            // };
            
            // setCenter(defaultCenter);

            // If we have map view data, fit bounds to show all markers
            if (mapViewData && mapViewData.length > 0) {
                const bounds = new window.google.maps.LatLngBounds();
                mapViewData.forEach(point => {
                    if (point.driver_details?.driver_current_latitude && point.driver_details?.driver_current_longitude) {
                        bounds.extend({
                            lat: parseFloat(point.driver_details.driver_current_latitude),
                            lng: parseFloat(point.driver_details.driver_current_longitude)
                        });
                    }
                    else{
                        bounds.extend({
                            lat: center.lat,
                            lng: center.lng
                        });
                    }
                });
                mapRef.current.fitBounds(bounds);
                mapRef.current.setZoom(10);
            } 
            else {
                // If no data, set default zoom
                mapRef.current.setZoom(12);
            }
        }
    }, [clientDemoFilter, mapViewData]);

    useEffect(()=>{
        const citycenter = cities.find((cityObj) => cityObj.city_id === cityFilter);
        if (citycenter?.center_latitude && citycenter?.center_longitude) {
            const geocenter = {
                lat: Number(citycenter?.center_latitude),
                lng: Number(citycenter?.center_longitude)
            };
            setInitialcityCenter(geocenter);
        }
    },[cityFilter])


    const onLoad = React.useCallback(function callback(map) {
        mapRef.current = map;
        setMapLoaded(true);  // Just set it to true instead of storing the map instance
        
        // If we have shuttle data, fit bounds
        if (gridShuttleClickData?.trip_details?.route_details?.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();
            gridShuttleClickData?.trip_details.route_details.forEach(stop => {
                bounds.extend({
                    lat: Number(stop.latitude),
                    lng: Number(stop.longitude)
                });
            });
            map.fitBounds(bounds);
        }

        // If we have pickup/drop points, show directions
        if (pickupLatLng && dropLatLng) {
            fetchDirections();
        }
    }, [gridShuttleClickData, pickupLatLng, dropLatLng]);

    const onUnmount = React.useCallback(function callback(map) {
        mapRef.current = null;
        setMapLoaded(false);
    }, []);

    // const fetchDirections = () => {
    //     if (pickupLatLng && dropLatLng && mapRef.current) {
    //         const bounds = new window.google.maps.LatLngBounds();
    //         bounds.extend(pickupLatLng);
    //         bounds.extend(dropLatLng);
    //         mapRef.current.fitBounds(bounds);

    //         if (mapRef.current.curvedPolyline) {
    //             mapRef.current.curvedPolyline.setMap(null);
    //         }
    //         if (mapRef.current.pickupMarker) {
    //             mapRef.current.pickupMarker.setMap(null);
    //         }
    //         if (mapRef.current.dropMarker) {
    //             mapRef.current.dropMarker.setMap(null);
    //         }

    //         const linePath = [];
    //         const numIntermediatePoints = 100;
    //         const curveFactor = 0.6; 
    //         const midLat = (pickupLatLng.lat + dropLatLng.lat) / 2;
    //         const midLng = (pickupLatLng.lng + dropLatLng.lng) / 2;
    //         const deltaLat = dropLatLng.lat - pickupLatLng.lat;
    //         const deltaLng = dropLatLng.lng - pickupLatLng.lng;
    //         const curveLat = midLat - deltaLat * curveFactor;
    //         const curveLng = midLng + deltaLng * curveFactor;

    //         const curveMidpoint = new window.google.maps.LatLng(curveLat, curveLng);

    //         for (let i = 0; i <= numIntermediatePoints; i++) {
    //             const fraction = i / numIntermediatePoints;
    //             const firstSegment = window.google.maps.geometry.spherical.interpolate(
    //                 pickupLatLng,
    //                 curveMidpoint,
    //                 fraction
    //             );
    //             const secondSegment = window.google.maps.geometry.spherical.interpolate(
    //                 curveMidpoint,
    //                 dropLatLng,
    //                 fraction
    //             );
    //             const interpolatedPoint = window.google.maps.geometry.spherical.interpolate(
    //                 firstSegment,
    //                 secondSegment,
    //                 fraction
    //             );
    //             linePath.push(interpolatedPoint);
    //         }

    //         const curvedPolyline = new window.google.maps.Polyline({
    //             path: linePath,
    //             geodesic: true,
    //             strokeColor: '#0065FF',
    //             strokeOpacity: 1.0,
    //             strokeWeight: 4
    //         });
    //         curvedPolyline.setMap(mapRef.current);
    //         mapRef.current.curvedPolyline = curvedPolyline;

    //         const pickupMarkerObj = new window.google.maps.Marker({
    //             position: pickupLatLng,
    //             map: mapRef.current,
    //             title: "Pickup",
    //             icon: {
    //                 url: pickupIcon,
    //                 scaledSize: new window.google.maps.Size(30, 30),
    //             },
    //         });
    //         mapRef.current.pickupMarker = pickupMarkerObj;

    //         const dropMarkerObj = new window.google.maps.Marker({
    //             position: dropLatLng,
    //             map: mapRef.current,
    //             title: "Drop",
    //             icon: {
    //                 url: dropIcon,
    //                 scaledSize: new window.google.maps.Size(30, 30),
    //             },
    //         });
    //         mapRef.current.dropMarker = dropMarkerObj;
    //     }
    // };


    const fetchDirections = () => {
        if (!pickupLatLng || !dropLatLng || !mapRef.current) return;

        // ---- 1. Gather all points: pickup -> waypoints -> drop ----
        const rawWaypoints = gridClickData?.engagement_details?.waypoints || [];
        const waypoints = rawWaypoints.map(wp => ({
            lat: Number(wp.latitude),
            lng: Number(wp.longitude),
        }));

        const allPoints = [pickupLatLng, ...waypoints, dropLatLng];

        // ---- 2. Fit map bounds around everything ----
        const bounds = new window.google.maps.LatLngBounds();
        allPoints.forEach(p => bounds.extend(p));
        mapRef.current.fitBounds(bounds);

        // ---- 3. Clear previous overlays ----
        if (mapRef.current.curvedPolylines) {
            mapRef.current.curvedPolylines.forEach(pl => pl.setMap(null));
        }
        mapRef.current.curvedPolylines = [];

        if (mapRef.current.waypointMarkers) {
            mapRef.current.waypointMarkers.forEach(m => m.setMap(null));
        }
        mapRef.current.waypointMarkers = [];

        if (mapRef.current.pickupMarker) {
            mapRef.current.pickupMarker.setMap(null);
            mapRef.current.pickupMarker = null;
        }
        if (mapRef.current.dropMarker) {
            mapRef.current.dropMarker.setMap(null);
            mapRef.current.dropMarker = null;
        }

        // ---- 4. Helper: build one curved (aerial) segment ----
        const buildCurvedPath = (start, end) => {
            const linePath = [];
            const numIntermediatePoints = 100;
            const curveFactor = 0.6;

            const midLat = (start.lat + end.lat) / 2;
            const midLng = (start.lng + end.lng) / 2;
            const deltaLat = end.lat - start.lat;
            const deltaLng = end.lng - start.lng;

            const curveMidpoint = new window.google.maps.LatLng(
                midLat - deltaLat * curveFactor,
                midLng + deltaLng * curveFactor
            );

            const startLL = new window.google.maps.LatLng(start.lat, start.lng);
            const endLL = new window.google.maps.LatLng(end.lat, end.lng);

            for (let i = 0; i <= numIntermediatePoints; i++) {
                const fraction = i / numIntermediatePoints;
                const firstSegment = window.google.maps.geometry.spherical.interpolate(
                    startLL, curveMidpoint, fraction
                );
                const secondSegment = window.google.maps.geometry.spherical.interpolate(
                    curveMidpoint, endLL, fraction
                );
                linePath.push(
                    window.google.maps.geometry.spherical.interpolate(
                        firstSegment, secondSegment, fraction
                    )
                );
            }
            return linePath;
        };

        // ---- 5. Draw one curved polyline per leg (pickup->1, 1->2, ..., n->drop) ----
        for (let i = 0; i < allPoints.length - 1; i++) {
            const segmentPolyline = new window.google.maps.Polyline({
                path: buildCurvedPath(allPoints[i], allPoints[i + 1]),
                geodesic: true,
                strokeColor: '#0065FF',
                strokeOpacity: 1.0,
                strokeWeight: 4,
            });
            segmentPolyline.setMap(mapRef.current);
            mapRef.current.curvedPolylines.push(segmentPolyline);
        }

        // ---- 6. Pickup & drop markers ----
        mapRef.current.pickupMarker = new window.google.maps.Marker({
            position: pickupLatLng,
            map: mapRef.current,
            title: "Pickup",
            icon: {
                url: pickupIcon,
                scaledSize: new window.google.maps.Size(30, 30),
            },
            zIndex: 3,
        });

        mapRef.current.dropMarker = new window.google.maps.Marker({
            position: dropLatLng,
            map: mapRef.current,
            title: "Drop",
            icon: {
                url: dropIcon,
                scaledSize: new window.google.maps.Size(30, 30),
            },
            zIndex: 3,
        });

        // ---- 7. Numbered waypoint markers (like MapViewPublic) ----
        waypoints.forEach((wp, index) => {
            const marker = new window.google.maps.Marker({
                position: wp,
                map: mapRef.current,
                title: rawWaypoints[index]?.address || `Stop ${index + 1}`,
                label: {
                    text: `${index + 1}`,
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "12px",
                },
                zIndex: 2,
            });
            mapRef.current.waypointMarkers.push(marker);
        });
    };
    useEffect(() => {
        const fetchHeatMapData = async () => {
          try {
            const token = localStorage.getItem('token');
            const url = serverUrl + "/customer/fetch_request_heat_map";
            const obj = {
              token: token,
              city_id: cityFilter,
            };
            const response = await makeGetRequestToUrl(url, obj);
            if (response.flag === 102) {
              console.log('Token is expired. Please login again');
              localStorage.removeItem('token');
              setErrorMessage('Your session has expired. Please log in again.');
              setTokenExpired(true);
              setTimeout(() => {
                navigate('/signup');
              }, 2000);
            }
            if (response.flag === 200) {
              setHeatMapData(response.data);
            }
          } catch (error) {
            console.log(error);
          }
        };
        fetchHeatMapData();
      }, [cityFilter]);

    useEffect(() => {
        if (mapRef.current && pickupLatLng && dropLatLng) {
            fetchDirections();
        }
    }, [pickupLatLng, dropLatLng,gridClickData]);

    useEffect(() => {
        // Clear any existing polylines
        if (currentBluePolyline) {
            currentBluePolyline.setMap(null);
            setCurrentBluePolyline(null);
        }
        if (currentGreyPolyline) {
            currentGreyPolyline.setMap(null);
            setCurrentGreyPolyline(null);
        }

        if (showShuttleRoute && gridShuttleClickData?.trip_details?.route_details?.length > 1) {
            const routeDetails = gridShuttleClickData.trip_details.route_details;
            
            // Find the index up to which stops are completed (arrived or skipped)
            let completedStops = [];
            let remainingStops = [];
            
            // Split stops into completed and remaining
            routeDetails.forEach((stop, index) => {
                if (stop.is_arrived || stop.is_skipped) {
                    completedStops.push(stop);
                } else {
                    // If this is the first remaining stop and we have completed stops,
                    // add the last completed stop to create a connection
                    if (remainingStops.length === 0 && completedStops.length > 0) {
                        remainingStops.push(completedStops[completedStops.length - 1]);
                    }
                    remainingStops.push(stop);
                }
            });

            // Convert stops to path coordinates
            const completedPath = completedStops.map(stop => ({
                lat: Number(stop.latitude),
                lng: Number(stop.longitude)
            }));

            const remainingPath = remainingStops.map(stop => ({
                lat: Number(stop.latitude),
                lng: Number(stop.longitude)
            }));

            // Create blue polyline for completed path
            if (mapRef.current && completedPath.length > 1) {
                const bluePolyline = new window.google.maps.Polyline({
                    path: completedPath,
                    geodesic: true,
                    strokeColor: '#0065FF',
                    strokeOpacity: 1.0,
                    strokeWeight: 4,
                    zIndex: 1
                });
                bluePolyline.setMap(mapRef.current);
                setCurrentBluePolyline(bluePolyline);
            }

            // Create grey polyline for remaining path
            if (mapRef.current && remainingPath.length > 1) {
                const greyPolyline = new window.google.maps.Polyline({
                    path: remainingPath,
                    geodesic: true,
                    strokeColor: '#808080',
                    strokeOpacity: 1.0,
                    strokeWeight: 4,
                    zIndex: 0
                });
                greyPolyline.setMap(mapRef.current);
                setCurrentGreyPolyline(greyPolyline);
            }

            // Clear any existing markers
            if (mapRef.current.curvedPolyline) {
                mapRef.current.curvedPolyline.setMap(null);
            }
            if (mapRef.current.pickupMarker) {
                mapRef.current.pickupMarker.setMap(null);
            }
            if (mapRef.current.dropMarker) {
                mapRef.current.dropMarker.setMap(null);
            }
        }
    }, [showShuttleRoute, gridShuttleClickData]);

    const handleGridClick = (data) => {
        setEndDriverLocation(false);
        setGridClidDriverID(data.driver_details?.driver_id);
        setSelectedGrid(data.engagement_details?.engagement_id);
        setGridClickData(data);
        focusOnVehicle({ lat: Number(data.engagement_details?.pickup_latitude), lng: Number(data.engagement_details?.pickup_longitude) });
        setGridClickedVehcileType(data?.vehicle_details?.vehicle_type);
        setPickupLatLng({ lat: Number(data.engagement_details?.pickup_latitude), lng: Number(data.engagement_details?.pickup_longitude) });
        setDropLatLng({ lat: Number(data.engagement_details?.drop_latitude), lng: Number(data.engagement_details?.drop_longitude) });
        if (window.pickupMarker) {
            window.pickupMarker.setMap(null);
        }
        if (window.dropMarker) {
            window.dropMarker.setMap(null);
        }
    };


function calculateBearing(start, end) {
  const toRad = (deg) => deg * Math.PI / 180;
  const toDeg = (rad) => rad * 180 / Math.PI;

  const lat1 = toRad(start.lat);
  const lat2 = toRad(end.lat);
  const dLng = toRad(end.lng - start.lng);

  const y = Math.sin(dLng) * Math.cos(lat2);
  const x =
    Math.cos(lat1) * Math.sin(lat2) -
    Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLng);

  const bearing = toDeg(Math.atan2(y, x));
  return (bearing + 360) % 360; // normalize
}

function normalizePath(start, end, stepMeters = 10) {
  const path = [];

  const startLatLng = new window.google.maps.LatLng(start.lat, start.lng);
  const endLatLng = new window.google.maps.LatLng(end.lat, end.lng);

  const totalDistance =
    window.google.maps.geometry.spherical.computeDistanceBetween(
      startLatLng,
      endLatLng
    );

  const steps = Math.max(1, Math.floor(totalDistance / stepMeters));

  for (let i = 0; i <= steps; i++) {
    const point = window.google.maps.geometry.spherical.interpolate(
      startLatLng,
      endLatLng,
      i / steps
    );

    path.push({
      lat: point.lat(),
      lng: point.lng(),
    });
  }

  return path;
}

function focusOnVehicle(latLng, targetZoom = 17) {
  if (!mapRef.current) return;

  mapRef.current.panTo(latLng);
  mapRef.current.panBy(0, -120);

  mapRef.current.setZoom(targetZoom);
}


const fetchTaxiLocation = async () => {
  try {

       const url = serverUrl + "/driver/fetch_current_location";
            const obj={
                token: token,
                driver_id :gridClickData.driver_details?.driver_id,
                engagement_id: gridClickData.engagement_details?.engagement_id,
            }

    const response = await makeGetRequestToUrl(url, obj);

    if (response.flag === 200 && response.data?.length) {
      const newLatLng = {
        lat: parseFloat(response.data[0].latitude),
        lng: parseFloat(response.data[0].longitude),
      };

      setTaxiPreviousLatLng(prev =>
        prev ? prev : newLatLng   // init once
      );

      setTaxiCurrentLatLng(prev => {
        if (!prev) return newLatLng;

        // 🔑 move previous forward
        setTaxiPreviousLatLng(prev);
        return newLatLng;
      });
    }
  } catch (e) {
    console.error(e);
  }
};


    useEffect(() => {
        if (!gridClickData || endDriverLocation) return;

        let intervalId;


        fetchTaxiLocation();
        intervalId = setInterval(fetchTaxiLocation, 6000); // Poll every 6 seconds

        return () => clearInterval(intervalId);

    }, [gridClickData, endDriverLocation]);


    useEffect(() => {
        // if (taxiMarker) taxiMarker.setMap(null);
        setTaxiMarker(null);
        setTaxiCurrentLatLng(null);
        setTaxiPreviousLatLng(null);
    }, [gridClickData]);

useEffect(() => {
  if (!taxiMarker || !taxiPreviousLatLng || !taxiCurrentLatLng) return;

  if (
    taxiPreviousLatLng.lat === taxiCurrentLatLng.lat &&
    taxiPreviousLatLng.lng === taxiCurrentLatLng.lng
  ) return;

  const startPos = new window.google.maps.LatLng(
    taxiPreviousLatLng.lat,
    taxiPreviousLatLng.lng
  );

  const endPos = new window.google.maps.LatLng(
    taxiCurrentLatLng.lat,
    taxiCurrentLatLng.lng
  );

  // ⏱ FIXED DURATION = API INTERVAL
  const DURATION = 6000; // ms

  let startTime = null;
  let frameId;

  function animate(timestamp) {
    if (!startTime) startTime = timestamp;

    const elapsed = timestamp - startTime;
    const t = Math.min(elapsed / DURATION, 1);

    const pos = window.google.maps.geometry.spherical.interpolate(
      startPos,
      endPos,
      t
    );

    taxiMarker.setPosition(pos);

    // 🔄 Rotate towards destination
    const bearing = calculateBearing(
      taxiPreviousLatLng,
      taxiCurrentLatLng
    );

    taxiMarker.setIcon({
      ...taxiMarker.getIcon(),
      rotation: bearing,
    });

    if (mapRef.current && followTaxiRef.current && elapsed % 300 < 16) {
      mapRef.current.panTo(pos);
    }

    if (t < 1) {
      frameId = requestAnimationFrame(animate);
    }
  }

  frameId = requestAnimationFrame(animate);
  return () => cancelAnimationFrame(frameId);

}, [taxiPreviousLatLng, taxiCurrentLatLng, taxiMarker]);





useEffect(() => {
  if (taxiMarker) taxiMarker.setMap(null);

  setTaxiMarker(null);
  setTaxiPreviousLatLng(null);
  setTaxiCurrentLatLng(null);
}, [gridClickData]);


useEffect(() => {
  if (!mapRef.current || !taxiCurrentLatLng || taxiMarker) return;

const carSymbol = {
  path: `
    M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z
  `,
  fillColor: "#91BDFF",
  fillOpacity: 1,
  strokeColor: "#1E2839",
  strokeWeight: 1,
  scale: 1,
  anchor: new window.google.maps.Point(0, 0),
  rotation: 0,
};

const autoSymbol = {
  path: `
    M10 0
    C4 0 0 4 0 10
    L0 30
    C0 36 4 40 10 40
    L18 40
    C24 40 28 36 28 30
    L28 10
    C28 4 24 0 18 0
    Z

    M4 10
    L24 10
    L24 22
    L4 22
    Z

    M8 -2
    L20 -2
    L20 4
    L8 4
    Z

    M6 36
    L22 36
    L22 42
    L6 42
    Z
  `,
  fillColor: "#1A1A1A",
  fillOpacity: 1,
  strokeColor: "#000",
  strokeWeight: 1,
  scale: 0.9,
  rotation: 0,
  anchor: new window.google.maps.Point(14, 42), // rear-center
};

const bikeSymbol = {
  path: `
    M9 0 L15 0 L15 4 L9 4 Z
    M9 34 L15 34 L15 38 L9 38 Z
    M11 4 L13 4 L15 18 L13 34 L11 34 L9 18 Z
    M6 6 L18 6 L18 8 L6 8 Z
  `,
  fillColor: "#111111",
  fillOpacity: 1,
  strokeColor: "#000",
  strokeWeight: 1,
  scale: 1,
  rotation: 0,
  anchor: new window.google.maps.Point(12, 38),
};



  const marker = new window.google.maps.Marker({
    position: taxiCurrentLatLng,
    map: mapRef.current,
    icon: carSymbol,
    // gridClickedVehcileType == 1 ? carSymbol : 
    //     gridClickedVehcileType == 2 ? bikeSymbol : 
    //     autoSymbol,
    scaledSize: new window.google.maps.Size(20, 20),
  });

  setTaxiMarker(marker);
}, [taxiCurrentLatLng, gridClickedVehcileType]);







    const handleShuttleGridClick = (data) => {
        setRideEndCheck(false);
        setSelectedGrid(data.trip_details?.route_id);
        setCurrentSessionId(data?.trip_details?.session_id);
        setGridShuttleClickData(data);
        gettrackshuttle(data?.trip_details?.session_id);
        
        if (data?.trip_details?.route_details && data?.trip_details.route_details.length > 0) {
            const firstStop = data?.trip_details.route_details[0];
            const lastStop = data?.trip_details.route_details[data?.trip_details.route_details.length - 1];
            
            setShuttlePickupLatLng({ 
                lat: Number(firstStop.latitude), 
                lng: Number(firstStop.longitude) 
            });
            setShuttleDropLatLng({ 
                lat: Number(lastStop.latitude), 
                lng: Number(lastStop.longitude)
            });
            
            // Set map center to first stop
            setCenter({
                lat: Number(firstStop.latitude),
                lng: Number(firstStop.longitude)
            });
        }
    }

    const getOngoingRides = async() =>{
        try{
            const token = localStorage.getItem('token');
            const timestamp = new Date().getTime();
            const url = serverUrl + "/panel/fetch_city_rides";
            const obj={
                token: token,
                timestamp: timestamp,
                city_id: cityFilter,
                status: statusFilter,
                ride_type: clientDemoFilter,
            }
            if (selectedRouteId) {
                obj.route_id = selectedRouteId;
            }
            const response =  await makeGetRequestToUrl(url, obj);
            

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            if(response.flag === 200){
                const mapViewData = response.data;
                setMapViewData(mapViewData);
                setMapViewData(mapViewData); // used for rendering on map
                // setAllMapViewData(mapViewData); // filtered list

                // Only update fullMapViewData if no route is selected
                if (!selectedRouteId) {
                    setFullMapViewData(mapViewData); // store full data for dropdown
                }
            }
            else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    useEffect(() => {
    if (!queryEngagementId || !mapViewData?.length) return;

    // Find the taxi engagement card
    const found = mapViewData.find(
        (item) => item?.engagement_details?.engagement_id?.toString() === queryEngagementId
    );

    if (found) {
        console.log("Auto-selected engagement:", found);

        // Auto-select card
        handleGridClick(found);

        // Scroll card into view (optional)
        setTimeout(() => {
            const el = document.getElementById(`card-${queryEngagementId}`);
            if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 200);
    }
}, [queryEngagementId, mapViewData]);

    useEffect(() => {
        getOngoingRides();
    },[cityFilter, statusFilter, clientDemoFilter,selectedRouteId]);

useEffect(() => {
    if (!shuttleMarker || !previousLatLng || !currentLatLng || !window.google?.maps?.geometry) {
      return;
    }
  
    const startPos = new window.google.maps.LatLng(
      Number(previousLatLng.lat),
      Number(previousLatLng.lng)
    );
    const endPos = new window.google.maps.LatLng(
      Number(currentLatLng.lat),
      Number(currentLatLng.lng)
    );
  
    const distance = window.google.maps.geometry.spherical.computeDistanceBetween(startPos, endPos);
  
    const speedMps = 2; // lower = slower/snail
    const duration = Math.max(2000, (distance / speedMps) * 1000); // at least 2s
  
    let start = null;
    let frame;
  
    function animate(now) {
      if (!start) start = now;
      const elapsed = now - start;
      const t = Math.min(elapsed / duration, 1);
  
      const pos = window.google.maps.geometry.spherical.interpolate(startPos, endPos, t);
      shuttleMarker.setPosition(pos);
  
      if (t < 1) {
        frame = requestAnimationFrame(animate);
      }
    }
  
    frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, [previousLatLng, currentLatLng, shuttleMarker]);

    useEffect(() => {
        if (!currentSessionId || rideEndCheck) return;
      
        let intervalId;
      
        const pollShuttleLocation = async () => {
          try {
            gettrackshuttle(currentSessionId);
          } catch (error) {
            console.error("Error fetching shuttle location:", error);
          }
        };
      
        pollShuttleLocation(); // initial fetch
        intervalId = setInterval(pollShuttleLocation, SHUTTLE_TRACK_POLL_INTERVAL);
      
        return () => clearInterval(intervalId); 
      }, [currentSessionId, rideEndCheck]);


    useEffect(() => {
        setPreviousLatLng(null);
        setCurrentLatLng(null);
        setAnimatedLatLng(null);
        setShuttleMarker(null);
    }, [currentSessionId]);

    const gettrackshuttle = async(sessionId) =>{
        try{
            const token = localStorage.getItem('token');
            // const timestamp = new Date().getTime();
            const url = serverUrl + "/shuttle/track_shuttle";
            const obj={
                token: token,
                session_id: sessionId,
            }
            const response =  await makeGetRequestToUrl(url, obj);
            

            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);
                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
            }

            if(response.flag === 412){
                setRideEndCheck(true);
            }

            if (response.flag === 200 && response.data && response.data.length > 0) {
                const latlongData = response.data[0];
              
                const newLatLng = {
                  lat: parseFloat(latlongData.latitude),
                  lng: parseFloat(latlongData.longitude),
                };              
                // If currentLatLng is null (first run), initialize both current and previous with the same value
                if (currentLatLng === null) {
                  setCurrentLatLng(newLatLng);
                  setPreviousLatLng(newLatLng);
                } else {
                  // Normal update cycle
                  setPreviousLatLng(currentLatLng);
                  setCurrentLatLng(newLatLng);
                }
              }
              
            else {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
        }
        catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const handleStatusChange = (event) => {
        setStatusFilter(event.target.value);
    };
    const handleGpsStatusChange = (event) => {
        setGpsStatusFilter(event);
    };

    const handlefilterChange = (event) => {
        setFilter(event.target.value);
    };
    const handleDemoClientTypeChange = (e) => {
        setClientDemoFilter(e.target.value);
    }

    const moveToshuttleMapViewDetails = (marker) => {
        navigate('/shuttle-map-details', {state: {marker: marker}});
    }

    const saveReassign = async() => {
        const token = localStorage.getItem('token');
        if(selectedReassignDriver==''){
            setMessage('Please select a driver first.');
            showSnackbar(true);
            return;
        }
        if(reassignDriversData.length==0){
            setMessage('No drivers available for reassignment');
            showSnackbar(true);
            return;
        }
        const payload = {
            user_id: gridClickData?.user_details?.user_id,
            driver_id: selectedReassignDriver,
            engagement_id: gridClickData?.engagement_details?.engagement_id,
            ride_eta: gridClickData?.engagement_details?.ride_time,
            // city_id: cityFilter
        };
        try {
            // const url = operationsUrl + '/airport/create_and_update_bookings';
            const url = autosUrl + '/customer/reassign_ride';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message);
                showSnackbar(true);
                setOpenReassign(false);
                setSelectedReassignDriver('');
                getOngoingRides();

            } else if (response.flag === 111) {
                setOngoingRideCheck(true);
                setOngoingRideCheckMessage(response.message);
                setOpenReassign(false);
                // setMessage(response.message)
                // showSnackbar(true);

            } else if (response.flag === 116) {
                setOngoingRideCheck(true);
                setOngoingRideCheckMessage(response.message);
                setOpenReassign(false);
                // setMessage(response.message)
                // showSnackbar(true);

            } else {
                setMessage(response.message)
                showSnackbar(true);
                setOpenReassign(false);
            }
        } catch (error) {
            setMessage(error);
        }
    }

    const cancelReassign = () => {
        setOpenReassign(false);
        setSelectedReassignDriver('');
    }
    useEffect(() => {
        const fetchCityDrivers = async () => {
            try{
                const token = localStorage.getItem('token');
                const timestamp = new Date().getTime();
                // const url = `${serverUrl}/driver/fetch_city_driver`;
                const url = serverUrl + "/driver/city_online_driver"
                const obj={
                    token: token, 
                    timestamp: timestamp,
                    city_id: cityFilter
                }
                const response =  await makeGetRequestToUrl(url, obj);

                if(response.flag==102){
                    console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);
                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
                }

                if(response.flag === 200){
                    const cityDriversData = response.data;
                    setReassignDriversData(cityDriversData);
                }
                else {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
            }
            catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchCityDrivers();
    }, [openReassign])

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    const markArrivedFunc = async(marker) => {
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            trip_engagement_id: marker.engagement_details?.engagement_id,
            driver_id: marker.driver_details?.driver_id
        };
        try {
        const url = operationsUrl + '/panel/mark_arrival';
        const response = await makePostRequestToUrl(url,payload);
        if (response.flag === 200) {
            setMessage(response.message)
            showSnackbar(true);
            getOngoingRides();
            
        } else {
            setMessage(response.message)
            showSnackbar(true);
        }
        } catch (error) {
            console.error('Error', error);
            setMessage(error);
        }
    }
    
    // Function to mark a specific stop as arrived
    const markStopArrivedFunc = async(marker, stopIndex) => {
        const token = localStorage.getItem('token');
        const payload = {
            // token: token,
            // driver_access_token
            driver_id: marker.driver_details?.driver_id,
            engagement_id: marker.engagement_details?.engagement_id,
            stop_id: marker.engagement_details?.waypoints[stopIndex].stop_id,
            is_panel_request: 1
        };
        try {
            const url = autosUrl + '/driver/mark_arrival_at_stop';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(`Stop ${stopIndex+1} marked as arrived`)
                showSnackbar(true);
                getOngoingRides(); // Refresh rides data to update stop statuses
            } else {
                setMessage(response.message || 'Failed to mark stop as arrived')
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error marking stop arrived:', error);
            setMessage(error.message || 'An error occurred');
            showSnackbar(true);
        }
    }

    const handleRouteSelect = (routeId) => {
        setSelectedRouteId(routeId);
        if (routeId) {
            getOngoingRides(routeId); // Pass the routeId if your function signature accepts it
        }
    };
    
    const startRideFunc = async(marker) => {
        // Placeholder for start ride functionality
        // const marker = selectedMarker;
        if (!marker) return;

        const token = localStorage.getItem('token');
        const payload = {
            // token: token,
            trip_engagement_id: marker.engagement_details?.engagement_id,
            driver_id: marker.driver_details?.driver_id,
            latitude: marker.driver_details?.driver_current_latitude,
            longitude: marker.driver_details?.driver_current_longitude,
            is_panel_request: 1,
            otp: marker?.engagement_details?.pickup_otp || 4343,
            admin_id: admin_id
        };
        try {
            const url = autosUrl + '/driver/start_ride';
            const response = await makePostRequestToUrl(url, payload);
            if (response.flag === 200) {
                setMessage(response.message);
                showSnackbar(true);
                getOngoingRides();
            } else {
                setMessage(response.message);
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error', error);
            setMessage(error);
        } finally {
            setOpenEndRideModal(false);
            setSelectedMarker(null);
        }
    };

    const endRideFunc = (marker) => {
        setSelectedMarker(marker);
        setOpenEndRideModal(true);
    };

const formatDateTimeWithOffset = (isoString) => {
    if (!isoString) return { date: null, time: null, offset: 0, time12Hour: null };
    
    const date = new Date(isoString);
    const timezoneOffsetMinutes = date.getTimezoneOffset();
    const offsetHours = Math.abs(Math.floor(timezoneOffsetMinutes / 60)).toString().padStart(2, '0');
    const offsetMinutes = Math.abs(timezoneOffsetMinutes % 60).toString().padStart(2, '0');
    const offsetSign = timezoneOffsetMinutes <= 0 ? '+' : '-';
    
    const formattedDate = date.toISOString().split('T')[0];
    const formattedTime = date.toTimeString().split(' ')[0];
    
    // Format time in 12-hour format with AM/PM
    let hours = date.getHours();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');
    const time12Hour = `${hours}:${minutes}:${seconds} ${ampm}`;
    
    return {
        date: formattedDate,
        time: formattedTime,
        time12Hour: time12Hour,
        offset: timezoneOffsetMinutes,
        formattedOffset: `UTC${offsetSign}${offsetHours}:${offsetMinutes}`
    };
};

    const confirmEndRide = async () => {
        const marker = selectedMarker;
        if (!marker) return;

        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            trip_engagement_id: marker.engagement_details?.engagement_id,
            driver_id: marker.driver_details?.driver_id
        };
        try {
            const url = operationsUrl + '/panel/end_ride';
            const response = await makePostRequestToUrl(url, payload);
            if (response.flag === 200) {
                setMessage(response.message);
                showSnackbar(true);
                getOngoingRides();
            } else {
                setMessage(response.message);
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error', error);
            setMessage(error);
        } finally {
            setOpenEndRideModal(false);
            setSelectedMarker(null);
        }
    };

    const handleCloseOngoingRideCheckModal = () => {
        setOngoingRideCheck(false);
        window.location.reload();
    };

    const handleCancelRide = async() => {
        const token = localStorage.getItem('token');
        if(refundPercentage==""){
            setMessage("Please enter refund percentage.");
            showSnackbar(true);
            return;
        }
        const payload = {
            token: token,
            trip_request_id: gridClickData?.engagement_details?.trip_request_id,
            user_id: gridClickData?.user_details?.user_id,
        };
        if(cancelRideReason!=""){
            payload.cancellation_reason = cancelRideReason;
        }
        if(hide_fare_on_map_view_cancel == 0){
            payload.admin_refund_percentage = refundPercentage;
        }
        try {
            const url = operationsUrl + '/panel/cancel_ride';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                setOpenTaxiCancelRide(false)
                setTimeout(() => {
                    getOngoingRides();
                }, 2000);
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error', error);
            setMessage(error);
        }
    }

    const handleOpenCancelRide = () => {
        setOpenTaxiCancelRide(true)
        setRefundPercentage('100')
        setCancelRideReason('')
    }

    return(
        <div>
            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Map View</Typography>

            <Grid2 item container spacing={2} sx={{marginTop:'1%'}}>
                <Grid2 item>
                    <Select
                        value={cityFilter}
                        onChange={(e) => handleFilterChange('city', e.target.value)}
                        displayEmpty
                        style={{
                            width: '220px',
                            height: '50px',
                            borderRadius: '8px',
                            backgroundColor: cityFilter ? '#F9F9F9' : '#FFFFFF',
                        }}
                    >
                        <MenuItem value="">Select City</MenuItem>
                        {cities.map((city) => (
                            <MenuItem key={city.city_id} value={city.city_id}>
                                {city.city_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>

                <Grid2 item>
                    <Select value={statusFilter} onChange={handleStatusChange} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: statusFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        {/* <MenuItem value="">Select Status</MenuItem> */}
                        <MenuItem value="1">Ongoing</MenuItem>
                        <MenuItem value="2">Accepted</MenuItem>
                        <MenuItem value="3">Arrived</MenuItem>
                        <MenuItem value="5">Started</MenuItem>
                        {/* {Object.entries(constants.panelengagmentStatus).map(([key, value]) => (
                            <MenuItem key={key} value={value}>
                                {key.charAt(0).toUpperCase() + key.slice(1).toLowerCase()}
                            </MenuItem>
                        ))} */}
                    </Select>
                </Grid2>

                {clientDemoFilter == "2" && show_driver_gps_status=="1" && (
                <Grid2 item>
                    <Select
                        value={gpsStatusFilter}
                        onChange={e => {
                        handleGpsStatusChange(e.target.value);
                        }}
                        displayEmpty
                        style={{width: '190px', height:'50px', borderRadius:'8px', backgroundColor: '#FFFFFF'}}
                        >
                        <MenuItem value="">Select GPS Status</MenuItem>
                        <MenuItem value="1">Online</MenuItem>
                        <MenuItem value="0">Offline</MenuItem>

                    </Select>
                </Grid2>
                )}

                {clientDemoType==1 || clientDemoType==3 || clientDemoType==2 && <Grid2 item>
                    <Select value={clientDemoFilter} onChange={handleDemoClientTypeChange} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: statusFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        {/* <MenuItem value="">Select Status</MenuItem> */}
                        {(clientDemoType==1 || clientDemoType==3) && <MenuItem value="1">Taxi</MenuItem>}
                        {(clientDemoType==2 || clientDemoType==3) && <MenuItem value="2">Shuttle</MenuItem>}
                        {/* <MenuItem value="3">Both</MenuItem> */}
                    </Select>
                </Grid2>}

                {clientDemoFilter == "2" && (
                <Grid2 item>
                    <Select
                        value={selectedRouteId}
                        onChange={e => {
                        handleRouteSelect(e.target.value);
                        }}
                        displayEmpty
                        style={{width: '190px', height:'50px', borderRadius:'8px', backgroundColor: '#FFFFFF'}}
                        >
                        <MenuItem value="">Select Route</MenuItem>
                        {/* {mapViewData.map(route => (
                        <MenuItem key={route?.trip_details?.route_id} value={route?.trip_details?.route_id}>
                        {route?.trip_details?.route_name}
                        </MenuItem>
                        ))} */}
                        {/* create unique route list */}
                        {allRoutes.map(route => (
                            <MenuItem key={route.route_id} value={route.route_id}>
                                {route.route_name}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid2>
                )}
                {/* <Grid2 item>
                    <Label sx={{fontSize:'16px',fontWeight:'500',display:'flex',alignItems:'center'}}>Filter</Label>
                    <Select value={filter} onChange={handlefilterChange} displayEmpty
                    style={{width: '190px',height:'50px',borderRadius:'8px',backgroundColor: statusFilter ? '#F9F9F9' : '#FFFFFF'}}>
                        <MenuItem value="pickupTime">PickUp Time</MenuItem>
                        <MenuItem value="engagementId">Engagement Id</MenuItem>
                    </Select>
                </Grid2> */}
                <Grid2 item xs={12} sm={6}>
                    <TextField
                        label={<span>Sort By </span>}
                        select
                        fullWidth
                        variant="outlined"
                        value={filter}
                        onChange={(e) => setFilter(e.target.value)}
                        InputProps={{
                            style: {height: '48px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                        }}
                        sx={{
                            '& .MuiOutlinedInput-notchedOutline': {borderColor: '#E0E0E0'},
                            '& .MuiInputLabel-root': {fontSize: '16px'},
                            '& .MuiSelect-select': {
                                padding: '14px 14px',
                                minWidth: '150px'
                            }
                        }}
                    >
                        <MenuItem value="pickupTime">PickUp Time</MenuItem>
                        <MenuItem value="engagementId">Engagement Id</MenuItem>
                    </TextField>
                </Grid2>
                <Grid2 item>
                </Grid2>
                {false && <Grid2 xs="auto">
                    <input type="number" placeholder="Driver Phone" className='filterBtn' value={driverPhoneFilter} onChange={(e) => setDriverPhoneFilter(e.target.value)} min="0"
                    onKeyDown={(e) => {
                        if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                            e.preventDefault();
                        }
                    }}
                    style={{
                        width: '200px',
                        height: '46px',
                        borderRadius: '8px',
                        backgroundColor: driverPhoneFilter ? '#F9F9F9' : '#FFFFFF',
                    }}
                        />
                </Grid2>}
                <Grid2 xs="auto">
                    <input type="number" placeholder="Engagement Id" className='filterBtn' value={driverEngagementIdFilter} onChange={(e) => setDriverEngagementIdFilter(e.target.value)} min="0"
                    onKeyDown={(e) => {
                        if (e.key === '-' || e.key === 'e' || e.key === 'E') {
                            e.preventDefault();
                        }
                    }}
                    style={{
                        width: '200px',
                        height: '46px',
                        borderRadius: '8px',
                        backgroundColor: driverEngagementIdFilter ? '#F9F9F9' : '#FFFFFF',
                    }}
                        />
                </Grid2>
                {client_id == 188 && <Grid2 xs="auto">
                    <input type="text" placeholder="Client Id" className='filterBtn' value={clientIdFilter} onChange={(e) => setclientIdFilter(e.target.value)}
                    style={{
                        width: '200px',
                        height: '46px',
                        borderRadius: '8px',
                        backgroundColor: clientIdFilter ? '#F9F9F9' : '#FFFFFF',
                    }}
                   />
                </Grid2>}
            </Grid2>

            {/* Taxi  ------   (clientDemoFilter==1) */}
            {clientDemoFilter==1 && (
                <Grid2 item container size={12} spacing={2}>
                    <Grid2 item size={4.2} sx={{ overflowY:'auto', maxHeight:'calc(100vh - 200px)'}}>
                        {filteredMapViewData &&  filteredMapViewData.length>0 ? 
                            (filteredMapViewData.map((marker, index) => (
                                <Grid2
                                    id={`card-${marker.engagement_details?.engagement_id}`}
                                    item
                                    className="mainBox"
                                    sx={{
                                        marginTop: '4%',
                                        cursor: 'pointer',
                                        border: selectedGrid === marker.engagement_details?.engagement_id ? "1px solid #83888E" : 'none',
                                        boxShadow: selectedGrid === marker.engagement_details?.engagement_id ? "2" : 'none'
                                    }}
                                    key={index}
                                    onClick={() => handleGridClick(marker)}
                                >

                                    {/* {marker.engagement_details?.is_scheduled_request==1 && (
                                        <Grid2 container justifyContent="space-between" alignItems="flex-start" sx={{ width: '100%', marginTop: '4px' }}>
                                        {marker.engagement_details?.is_scheduled_request == 1 && (
                                            <Grid2 item>
                                                <Typography sx={{
                                                    fontSize: '12px',
                                                    color: '#fff',
                                                    backgroundColor: '#F5BB19',
                                                    borderRadius: '4px',
                                                    padding: '2px 6px',
                                                    display: 'inline-block'
                                                }}>
                                                    SCHEDULED
                                                </Typography>
                                            </Grid2>
                                        )}
                                    </Grid2>
                                    )}
                                    <Grid2 item container justifyContent="space-between" alignItems="center" sx={{ marginTop: '8px' }}>
                                        <Grid2 item>
                                            <Typography sx={{fontSize:'12px', color:'#83888E'}}>Engagement ID </Typography>
                                            <Typography sx={{fontSize:'16px'}}>ID: {marker.engagement_details?.engagement_id}</Typography>
                                        </Grid2>
                                        <Grid2 item>
                                            <Button
                                                variant="contained"
                                                style={{
                                                    backgroundColor: statusFilter==1 ? '#E7F8F2' : '#F9E9E9',
                                                    color: statusFilter==1 ? '#0DBA78' : '#D14545',
                                                    textTransform: 'none',
                                                    pointerEvents: 'none',
                                                    borderRadius: '6px',
                                                    minWidth: '60px',
                                                    border:'none',
                                                    boxShadow: 'none',
                                                    fontFamily: 'Poppins',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '4px'
                                                }}
                                            >
                                                <FiberManualRecordIcon style={{ fontSize: '14px' }}/>
                                                {statusFilter==1 ? 'Active' : 'Inactive'}
                                            </Button>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item>
                                        <Typography sx={{fontSize:'12px', marginTop: '4px', textAlign: 'right'}}>
                                            {formatDateTimeWithOffset(marker.engagement_details?.pickup_time)?.time12Hour} {" "} 
                                            On {formatDateTimeWithOffset(marker.engagement_details?.pickup_time)?.date}
                                        </Typography>
                                    </Grid2> */}

                                    <Grid2 container direction="column" sx={{ width: '100%', marginTop: '4px' }}>
                                        <Grid2 container justifyContent="space-between" alignItems="center">
                                            <Grid2>

                                                <Grid2 item>
                                                    {marker.engagement_details?.is_scheduled_request == 1 && (
                                                        <Typography sx={{
                                                            fontSize: '12px',
                                                            color: '#fff',
                                                            backgroundColor: '#F5BB19',
                                                            borderRadius: '4px',
                                                            padding: '2px 6px',
                                                            display: 'inline-block'
                                                        }}>
                                                            SCHEDULED
                                                        </Typography>
                                                    )}
                                                </Grid2>
                                                <Grid2 item>
                                                    <Typography sx={{ fontSize: '12px', color: '#83888E' }}>Engagement ID </Typography>
                                                    <Typography sx={{ fontSize: '16px' }}>ID: {marker.engagement_details?.engagement_id}</Typography>
                                                </Grid2>
                                            </Grid2>
                                            <Grid2>
                                                <Grid2 item>
                                                    <Button
                                                        variant="contained"
                                                        style={{
                                                            backgroundColor: statusFilter == 1 || statusFilter == 2 || statusFilter == 3 || statusFilter == 5 ? '#E7F8F2' : '#F9E9E9',
                                                            color: statusFilter == 1 || statusFilter == 2 || statusFilter == 3 || statusFilter == 5 ? '#0DBA78' : '#D14545',
                                                            textTransform: 'none',
                                                            pointerEvents: 'none',
                                                            borderRadius: '6px',
                                                            minWidth: '60px',
                                                            border: 'none',
                                                            boxShadow: 'none',
                                                            fontFamily: 'Poppins',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '4px',
                                                            marginLeft: 'auto',
                                                            marginBottom: '8px',
                                                            marginTop:'-10px'
                                                        }}
                                                    >
                                                        <FiberManualRecordIcon style={{ fontSize: '14px' }} />
                                                        {statusFilter == 1 || statusFilter == 2 || statusFilter == 3 || statusFilter == 5 ? 'Active' : 'Inactive'}
                                                    </Button>
                                                </Grid2>
                                                <Grid2 container justifyContent="flex-end" sx={{ width: '100%', marginTop: '4px' }}>
                                                <Typography sx={{ fontSize: '12px' }}>
                                                    {formatDateTimeWithOffset(marker.engagement_details?.pickup_time)?.time12Hour} {" "}
                                                    On {formatDateTimeWithOffset(marker.engagement_details?.pickup_time)?.date}
                                                </Typography>
                                            </Grid2>
                                            </Grid2>
                                            
                                        </Grid2>
                                    </Grid2>

                                    <Grid2 item container sx={{padding:'2%', marginTop:'2%'}}>
                                        <Grid2 item size={1}>
                                            <img src={pickupMarker} alt="pickup marker" width="20px" height="20px" />
                                        </Grid2>
                                        <Grid2 item size={11}>
                                            <Typography sx={{fontSize:'14px'}}>{marker.engagement_details?.pickup_address}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <hr style={{border: 'none', borderTop: '2px dotted #D1D5DB', marginLeft:'36px'}} />

                                    <Grid2 item container sx={{padding:'2%'}}>
                                        <Grid2 item size={1}>
                                            <img src={dropMarker} alt="drop marker" width="20px" height="20px" />
                                        </Grid2>
                                        <Grid2 item size={11}>
                                            <Typography sx={{fontSize:'14px'}}>{marker.engagement_details?.drop_address}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <hr style={{borderTop: '1px solid #D1D5DB'}} />

                                    <Grid2 item container sx={{marginTop:'2%'}}>
                                        <Grid2 item size={5} sx={{display:'flex', alignItems:'center'}}>
                                            <Grid2>
                                                {marker.engagement_details?.vehicle_type==1 && (
                                                    <Grid2><img src={vehicleTypeCar} alt="taxi"/></Grid2>
                                                )}
                                                {marker.engagement_details?.vehicle_type==2 && (
                                                    <Grid2><img src={vehicleTypeBike} alt="bike"/></Grid2>
                                                )}
                                                {marker.engagement_details?.vehicle_type==3 && (
                                                    <Grid2><img src={vehicletypeAuto} alt="auto"/></Grid2>
                                                )}
                                            </Grid2>
                                            <Grid2 sx={{marginLeft:'2%'}}>
                                                <Typography sx={{fontSize:'12px', color:'#83888E'}}>Economy</Typography>
                                                <Typography sx={{color:'#4E545D', fontSize:'14px'}}>{marker.vehicle_details?.vehicle_no}</Typography>
                                            </Grid2>
                                        </Grid2>
                                        <Grid2 item size={7} sx={{justifyContent:'flex-end', display:'flex'}}>
                                            {(taxi_show_reassign_ride_button == 1 && marker.engagement_details?.status==constants.taxiEngagementStatus.ACCEPTED) && <Button sx={{border: '1px solid #0065ff', borderRadius:'10px', marginRight:'4px'}} 
                                            onClick={() => setOpenReassign(true)}
                                            >
                                                <Typography sx={{textTransform:'none', color:'#0065ff'}}>Reassign</Typography>
                                            </Button>}

                                            {(taxi_show_start_ride_button==1 && marker.engagement_details?.status==constants.taxiEngagementStatus.ARRIVED) && 
                                                <Button sx={{border: '1px solid #0065ff', borderRadius:'10px'}} 
                                                onClick={() => startRideFunc(marker)}
                                                >
                                                    <Typography sx={{textTransform:'none', color:'#0065ff'}}>Start Ride</Typography>
                                                </Button>
                                            }

                                            {(taxi_show_end_ride_button==1 && marker.engagement_details?.status==constants.taxiEngagementStatus.STARTED && 
                                               // Check if waypoints exist and if the last waypoint has status 1 (arrived)
                                               ((marker.engagement_details?.waypoints && marker.engagement_details?.stops > 0) ? 
                                                  marker.engagement_details.waypoints[marker.engagement_details.stops-1]?.status === 1 : true)) && 
                                                <Button sx={{border: '1px solid #0065ff', borderRadius:'10px'}} 
                                                onClick={() => endRideFunc(marker)}
                                                >
                                                    <Typography sx={{textTransform:'none', color:'#0065ff'}}>End Ride</Typography>
                                                </Button>
                                            }

                                            {(taxi_show_mark_arrived_button==1 && marker.engagement_details?.status==constants.taxiEngagementStatus.ACCEPTED) && 
                                                <Button sx={{border: '1px solid #0065ff', borderRadius:'10px'}} 
                                                onClick={() => markArrivedFunc(marker)}
                                                >
                                                    <Typography sx={{textTransform:'none', color:'#0065ff'}}>Mark Arrived</Typography>
                                                </Button>
                                            }

                                            {/* Show Mark Stop X Arrived buttons for each waypoint without a status */}
                                            {(taxi_show_mark_arrived_button_for_stops==1 && marker.engagement_details?.status==constants.taxiEngagementStatus.STARTED && marker.engagement_details?.waypoints!=null) && (() => {
                                                // Find the first waypoint without a status
                                                const firstPendingIdx = marker.engagement_details?.waypoints?.findIndex(stop => !stop.status);
                                                if (firstPendingIdx !== -1) {
                                                    return (
                                                        <Button 
                                                            key={`stop-${firstPendingIdx}`}
                                                            sx={{border: '1px solid #0065ff', borderRadius:'10px'}} 
                                                            onClick={() => markStopArrivedFunc(marker, firstPendingIdx)}
                                                        >
                                                            <Typography sx={{textTransform:'none', color:'#0065ff', fontSize:'14px'}}>Mark Stop {firstPendingIdx+1} Arrived</Typography>
                                                        </Button>
                                                    );
                                                }
                                                return null;
                                            })()
                                            }


                                            {show_map_view_cancel_button==1 && (
                                                <Button sx={{border: '1px solid #D14545', borderRadius:'10px', marginLeft:'4px'}} 
                                                onClick={handleOpenCancelRide}
                                                >
                                                    <Typography sx={{textTransform:'none', color:'#D14545'}}>Cancel</Typography>
                                                </Button>
                                            )}
                                        </Grid2>
                                        
                                    </Grid2>
                                </Grid2>
                            )))
                            : (<div style={styles.errorBox}>
                                <p>No driver is online at this time.</p>
                            </div>)
                        }
                    </Grid2>

                    {!gridClickData && (
                        <Grid2 item size={7.5}>
                            <Grid2 item sx={{marginTop:'2%'}}>
                                {isLoaded ? (
                                    <GoogleMap
                                    mapContainerStyle={containerStyleMain}
                                    center={initialcityCenter}
                                    zoom={6}
                                    onLoad={onLoad}
                                    onUnmount={onUnmount}
                                >
                                    {/* Render Markers */}
                                    {filteredMapViewData && filteredMapViewData.length > 0 && filteredMapViewData.map((marker, index) => {
                                        const engagementId = marker.engagement_details?.engagement_id || 'N/A';
                                        const driverName = marker.driver_details?.driver_name || 'Unknown Driver';
                                        const phone = marker.driver_details?.driver_phone_number || 'N/A';
                                        
                                        return (
                                            <Marker
                                                key={index}
                                                position={{
                                                    lat: Number(marker.driver_details?.driver_current_latitude),
                                                    lng: Number(marker.driver_details?.driver_current_longitude),
                                                }}
                                                title={`Engagement ID: ${engagementId}\nDriver: ${driverName}\nPhone: ${phone}`}
                                                icon={{
                                                    url: mapPin,
                                                    scaledSize: new window.google.maps.Size(30, 30),
                                                }}
                                            />
                                        );
                                    })}
                                
                                    {/* Render Heatmap Layer if heatMapData is available */}
                                    {heatMapData && heatMapData.length > 0 && (
                                        <HeatmapLayer
                                            data={getHeatmapData(heatMapData)}
                                            options={{
                                                radius: 20,
                                                opacity: 1,
                                                dissipating: true,
                                                maxIntensity: 1,
                                                gradient: [
                                                    'rgba(0, 255, 255, 0)',
                                                    '#00FF00',
                                                    '#FFFF00',
                                                    'rgba(255, 0, 0, 0.75)',
                                                ],
                                            }}
                                        />
                                    )}
                                </GoogleMap>
                                
                                    
                                ): (<></>)}

                            </Grid2>
                        </Grid2>
                    )}

                    {gridClickData && (
                        <Grid2 item size={7.8}>
                            <Grid2 item sx={{marginTop:'2%'}}>
                                {isLoaded ? (
                                    <GoogleMap 
                                    mapContainerStyle={containerStyle}
                                    center={center}
                                    zoom={6} 
                                    onLoad={(map) => {
                                        onLoad(map);       // keep your existing onLoad logic
                                        setTaxiMapRef(map); // store map for taxi tracking
                                    }}
                                    onUnmount={onUnmount}>
                                        {/* {pickupLatLng && (
                                            <Marker key={gridClickData.driver_details?.driver_id} position={pickupLatLng}
                                                title={'pickup'}
                                                icon={{
                                                    url: pickupIcon,
                                                    scaledSize: new window.google.maps.Size(30, 30)
                                                }} 
                                            />
                                        )}
                                        {dropLatLng && (
                                            <Marker key={gridClickData.engagement_details?.engagement_id} position={dropLatLng}
                                                title={'drop'}
                                                icon={{
                                                    url: dropIcon,
                                                    scaledSize: new window.google.maps.Size(30, 30)
                                                }} 
                                            />
                                        )} */}
                                        {/* {taxiCurrentLatLng && (
                                            <Marker
                                                position={{
                                                    lat: taxiCurrentLatLng.lat,
                                                    lng: taxiCurrentLatLng.lng
                                                }}
                                                icon={{
                                                    url: gridClickedVehcileType == 1 ? CarIcon : 
                                                          gridClickedVehcileType == 2 ? BikeIcon : 
                                                          AutoIcon,
                                                    scaledSize: new window.google.maps.Size(70, 40)
                                                }}
                                                // onLoad={(marker) => {
                                                //     setTaxiMarker(marker);
                                                //     marker.setPosition({
                                                //         lat: taxiCurrentLatLng.lat,
                                                //         lng: taxiCurrentLatLng.lng,
                                                //     });
                                                // }}
                                            />
                                        )} */}
                                        {/* {taxiCurrentLatLng && (
                                            <Marker
                                                position={{ lat: Number(taxiCurrentLatLng.lat), lng: Number(taxiCurrentLatLng.lng) }}
                                                icon={{ url: gridClickedVehcileType == 1 ? CarIcon : 
                                                          gridClickedVehcileType == 2 ? BikeIcon : 
                                                          AutoIcon, scaledSize: new window.google.maps.Size(100, 60) }}
                                                onLoad={(marker) => {
                                                setTaxiMarker(marker);
                                                marker.setPosition({
                                                    lat: Number(taxiCurrentLatLng.lat),
                                                    lng: Number(taxiCurrentLatLng.lng),
                                                });
                                                }}
                                            />
                                            )} */}

                                    </GoogleMap>
                                ): (<></>)}
                            </Grid2>
                        
                            <Grid2 item sx={{backgroundColor:'#fff', borderRadius:"12px"}}>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                        <Tab label="Trip Details" {...a11yProps(0)} sx={{textTransform: 'none'}} />
                                        <Tab label="Driver Info" {...a11yProps(1)} sx={{textTransform: 'none'}} />
                                        <Tab label="Customer Info" {...a11yProps(2)} sx={{textTransform: 'none'}} />
                                        <Tab label="Vehicle Details" {...a11yProps(3)} sx={{textTransform: 'none'}} />
                                        <Tab label="Payment Details" {...a11yProps(4)} sx={{textTransform: 'none'}} />
                                    </Tabs>
                                </Box>

                                <CustomTabPanel value={value} index={0}>
                                    <Grid2 container sx={{paddingLeft:'16px', paddingTop:'10px'}}>
                                        <Grid2 item size={2}>
                                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Engagement ID</Typography>
                                            <Typography sx={{fontSize:'16px'}}>ID: {gridClickData.engagement_details?.engagement_id}</Typography>
                                        </Grid2>
                                        <Grid2 item size={2}>
                                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Vehicle Type</Typography>
                                            {gridClickData.engagement_details?.vehicle_type==1 && (
                                                <Grid2><img src={vehicleTypeCar} alt="taxi"/></Grid2>
                                            )}
                                            {gridClickData.engagement_details?.vehicle_type==2 && (
                                                <Grid2><img src={vehicleTypeBike} alt="bike"/></Grid2>
                                            )}
                                            {gridClickData.engagement_details?.vehicle_type==3 && (
                                                <Grid2><img src={vehicletypeAuto} alt="auto"/></Grid2>
                                            )}
                                        </Grid2>
                                        <Grid2 item size={2}>
                                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Ride Start Date</Typography>
                                            <Typography sx={{fontSize:'14px'}}>
                                                {gridClickData.engagement_details?.pickup_time ? gridClickData.engagement_details?.pickup_time?.split('T')[0] : '--'}
                                            </Typography>
                                        </Grid2>
                                        
                                        <Grid2 item size={1.8}>
                                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Start Time</Typography>
                                            <Typography sx={{fontSize:'14px'}}>
                                                {gridClickData.engagement_details?.pickup_time
                                                    ? new Date(gridClickData.engagement_details.pickup_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
                                                    : '--'}
                                            </Typography>
                                        </Grid2>
                                        <Grid2 item size={2.2}>
                                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Booking Distance</Typography>
                                            <Typography sx={{fontSize:'14px'}}>
                                                {gridClickData.engagement_details?.ride_distance} km</Typography>
                                        </Grid2>
                                        <Grid2 item size={2}>
                                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Pickup OTP</Typography>
                                            <Typography sx={{fontSize:'14px'}}>
                                                {gridClickData.engagement_details?.pickup_otp}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <hr/>

                                    <Grid2 container sx={{paddingLeft:'12px', paddingBottom:'8px'}}>
                                        <Grid2 item size={6}>
                                            <Grid2 item sx={{display:'flex'}}>
                                                <img src={pickupMarker} alt="pickup loc" height="20px" width="20px" />
                                                <Typography sx={{color:'#83888E', fontSize:'14px', marginLeft:'2%'}}>Pickup Location</Typography>
                                            </Grid2>
                                            <Grid2 item>
                                                <Typography sx={{marginLeft:'2%', fontSize:'14px', marginTop:'1%'}}>{gridClickData.engagement_details?.pickup_address}</Typography>
                                            </Grid2>
                                        </Grid2>
                                        <Grid2 item size={6}>
                                            <Grid2 item sx={{display:'flex'}}>
                                                <img src={dropMarker} alt="drop loc" height="20px" width="20px"/>
                                                <Typography sx={{color:'#83888E', fontSize:'14px', marginLeft:'2%'}}>Drop Address</Typography>
                                            </Grid2>
                                            <Grid2 item>
                                                <Typography sx={{marginLeft:'2%', fontSize:'14px', marginTop:'1%'}}>{gridClickData.engagement_details?.drop_address}</Typography>
                                            </Grid2>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 item>
                                        {gridClickData.engagement_details?.waypoints?.map((item, index) => (
                                            <>
                                                <div key={index}>
                                                    <Grid2 sx={{ marginTop:'1%',display:'flex', alignItems:'center', paddingLeft:'2%'}}>
                                                        <span style={{
                                                            display: 'inline-block',
                                                            minWidth: 20,
                                                            minHeight: 20,
                                                            borderRadius: '50%',
                                                            background: '#2A313C',
                                                            color: '#fff',
                                                            fontWeight: 500,
                                                            textAlign: 'center',
                                                            lineHeight: '20px',
                                                            marginRight: 8
                                                        }}>{index+1}</span>
                                                        <Typography>{item.address}</Typography>
                                                        
                                                    </Grid2>
                                                    <hr style={{border: 'none', borderTop: '1px dotted #E3E5E8'}}/>
                                                            
                                                </div>
                                            </>
                                        ))}
                                    </Grid2>
                                </CustomTabPanel>

                                <CustomTabPanel value={value} index={1}>
                                    
                                    <Grid2 container sx={{ width:'auto', minWidth:'180px', padding:'16px'}}>
                                        <Grid2>
                                            <Avatar sx={{borderColor:'#0065FF', border:1}} alt={gridClickData.driver_details?.driver_name} src={gridClickData.driver_details?.driver_image} ></Avatar>
                                        </Grid2>
                                        <Grid2 item sx={{ml:'8px',textAlign:'left'}}>
                                            <Grid2>
                                                <Typography>{gridClickData.driver_details?.driver_name}</Typography>
                                            </Grid2>
                                            <Grid2>
                                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Rating: {gridClickData.driver_details?.total_rating}</Typography>
                                            </Grid2>
                                        </Grid2>
                                        {(is_driver_debt_limit_enabled==1 && gridClickData.driver_details?.driver_wallet_balance < debtLimit) && (
                                            <Typography 
                                                sx={{
                                                    color: '#eb530daa',
                                                    borderRadius: '4px',
                                                    marginLeft:'1%',
                                                    fontWeight: 'medium',
                                                }}
                                            >
                                                (In Debt)
                                            </Typography>
                                        )}
                                    </Grid2>

                                    <Grid2 container spacing={2} sx={{paddingLeft:'16px', paddingBottom:'12px'}}>
                                        <Grid2 item size={1.8}>
                                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Driver ID</Typography>
                                            <Typography sx={{fontSize:'16px', wordBreak: 'break-word'}}>{gridClickData.driver_details?.driver_id}</Typography>
                                        </Grid2>
                                        <Grid2 item size={2.5}>
                                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Mobile Number</Typography>
                                            <Typography sx={{fontSize:'16px', wordBreak: 'break-word'}}>{gridClickData.driver_details?.driver_phone_number}</Typography>
                                        </Grid2>
                                        <Grid2 item size={3.2}>
                                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Email</Typography>
                                            <Typography sx={{fontSize:'16px', wordBreak: 'break-word'}}>{gridClickData.driver_details?.driver_email}</Typography>
                                        </Grid2>
                                        <Grid2 item size={2.2}>
                                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>City</Typography>
                                            <Typography sx={{fontSize:'16px', wordBreak: 'break-word'}}>{gridClickData.engagement_details.city_name}</Typography>
                                        </Grid2>
                                        <Grid2 item size={2}>
                                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Trips</Typography>
                                            <Typography sx={{fontSize:'16px', wordBreak: 'break-word'}}>{gridClickData.driver_details?.total_trips}</Typography>
                                        </Grid2>
                                    </Grid2>
                                </CustomTabPanel>

                                <CustomTabPanel value={value} index={2}>

                                    <Grid2 container sx={{ width:'auto', minWidth:'180px', padding:'16px'}}>
                                        <Grid2>
                                            <Avatar sx={{borderColor:'#0065FF', border:1}} alt={gridClickData.user_details?.user_name} src={gridClickData.user_details?.user_image} ></Avatar>
                                        </Grid2>
                                        <Grid2 item sx={{ml:'8px',textAlign:'left'}}>
                                            <Grid2>
                                                <Typography>{gridClickData.user_details?.user_name}</Typography>
                                            </Grid2>
                                            <Grid2>
                                                <Typography sx={{color:'#83888E', fontSize:'14px'}}>Rating: {gridClickData.user_details?.total_rating}</Typography>
                                            </Grid2>
                                        </Grid2>
                                    </Grid2>
                                    <Grid2 container spacing={2} sx={{paddingLeft:'16px', paddingBottom:'12px'}}>
                                        <Grid2 item size={1.8}>
                                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>User ID</Typography>
                                            <Typography sx={{fontSize:'16px', wordBreak: 'break-word'}}>{gridClickData.user_details?.user_id}</Typography>
                                        </Grid2>
                                        <Grid2 item size={2.5}>
                                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Mobile Number</Typography>
                                            <Typography sx={{fontSize:'16px', wordBreak: 'break-word'}}>{gridClickData.user_details?.user_phone_number}</Typography>
                                        </Grid2>
                                        <Grid2 item size={3.2}>
                                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Email</Typography>
                                            <Typography sx={{fontSize:'16px', wordBreak: 'break-word'}}>{gridClickData.user_details?.user_email}</Typography>
                                        </Grid2>
                                        <Grid2 item size={2.2}>
                                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>City</Typography>
                                            <Typography sx={{fontSize:'16px', wordBreak: 'break-word'}}>{gridClickData.engagement_details.city_name}</Typography>
                                        </Grid2>
                                        <Grid2 item size={2}>
                                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Trips</Typography>
                                            <Typography sx={{fontSize:'16px', wordBreak: 'break-word'}}>{gridClickData.user_details?.total_trips}</Typography>
                                        </Grid2>
                                    </Grid2>
                                </CustomTabPanel>

                                <CustomTabPanel value={value} index={3}>
                                    <Grid2 item container sx={{padding:'16px'}}>
                                        <Grid2 item size={2}>
                                            {gridClickData.engagement_details?.vehicle_type==1 && (
                                                <Grid2><img src={vehicleTypeCar} alt="taxi"/></Grid2>
                                            )}
                                            {gridClickData.engagement_details?.vehicle_type==2 && (
                                                <Grid2><img src={vehicleTypeBike} alt="bike"/></Grid2>
                                            )}
                                            {gridClickData.engagement_details?.vehicle_type==3 && (
                                                <Grid2><img src={vehicletypeAuto} alt="auto"/></Grid2>
                                            )}
                                        </Grid2>
                                        <Grid2 item size={3}>
                                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Vehicle Type</Typography>
                                            <Typography sx={{fontSize:'14px'}}>
                                                                {gridClickData.vehicle_details?.vehicle_type === 1 ? 'Taxi' : gridClickData.vehicle_details?.vehicle_type === 2 ? 'Bike' : gridClickData.vehicle_details?.vehicle_type === 3 ? 'Auto' : 'Unknown'}</Typography>
                                        </Grid2>
                                        <Grid2 item size={3}>
                                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Vehicle Number</Typography>
                                            <Typography sx={{fontSize:'14px'}}>{gridClickData.vehicle_details?.vehicle_no}</Typography>
                                        </Grid2>
                                    </Grid2>
                                </CustomTabPanel>

                                <CustomTabPanel value={value} index={4}>
                                    <Grid2 container sx={{paddingLeft:'16px', paddingBottom:'12px', paddingTop:'16px'}}>
                                        <Grid2 item size={3}>
                                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Payment Mode</Typography>
                                            <Typography sx={{fontSize:'16px'}}>{gridClickData.payment_details?.payment_mode==1 ? 'CASH' : 'STRIPE'}</Typography>
                                        </Grid2>
                                        <Grid2 item size={3}>
                                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Fare</Typography>
                                            <Typography sx={{fontSize:'16px'}}>{gridClickData.payment_details?.trip_fare}</Typography>
                                        </Grid2>
                                        <Grid2 item size={3}>
                                            <Typography sx={{color:'#83888E', fontSize:'14px'}}>Payment Status</Typography>
                                            <Typography sx={{fontSize:'16px'}}>{gridClickData.payment_details?.payment_status == 0 ? 'Pending' : 'Success'}</Typography>
                                        </Grid2>
                                        
                                    </Grid2>
                                </CustomTabPanel>
                            </Grid2>
                        </Grid2>
                    )}

                    <Modal open={openReassign} onClose={() => {
                        setOpenReassign(false);
                        setSelectedReassignDriver('');
                    }}  aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                        <Box sx={style}>
                            <Typography id="modal-modal-title" variant="h6" component="h2">
                                Reassign
                            </Typography>
                            <hr/>
                            <Grid2 id="modal-modal-description" sx={{ mt: 2 }}>

                                <Grid2 item container size={12} sx={{ marginTop:'10%', alignItems:'center'}}>
                                    <Grid2 item size={3}>
                                        <Typography>Select Driver</Typography>
                                    </Grid2>
                                    <Grid2 item size={1}><Typography sx={{marginLeft:'4%'}}>:</Typography></Grid2>
                                    <Grid2 item size={7}>
                                        <Select 
                                            sx={{
                                                height: '48px',borderRadius: '8px',backgroundColor: '#FFFFFF',
                                                '& .MuiSelect-select': {display: 'flex',alignItems: 'center',paddingLeft: '12px'}
                                            }}
                                            value={selectedReassignDriver} 
                                            fullWidth
                                            displayEmpty
                                            renderValue={(selected) => {
                                                const filteredDrivers = reassignDriversData?.filter(
                                                driver => driver?.vehicle_type === gridClickData?.engagement_details?.vehicle_type
                                                );
                                                return (
                                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <PersonIcon sx={{ color: '#666', mr: 1 }} />
                                                    {selected ? filteredDrivers.find(driver => driver.driver_id === selected)?.driver_name : 'Select Driver'}
                                                    </Box>
                                                );
                                            }}
                                            onChange={(e) => setSelectedReassignDriver(e.target.value)}
                                        >
                                            <MenuItem value="" disabled>
                                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                    <PersonIcon sx={{ color: '#666', mr: 1 }} />
                                                    Select Driver
                                                </Box>
                                            </MenuItem>
                                            {reassignDriversData
                                                ?.filter(driver => driver?.vehicle_type === gridClickData?.engagement_details?.vehicle_type)
                                                ?.map((driver) => (
                                                    <MenuItem key={driver.driver_id} value={driver.driver_id}>
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                                            <Typography>
                                                                {driver.driver_name}
                                                            </Typography>
                                                            {(is_driver_debt_limit_enabled==1) &&
                                                                (driver?.driver_wallet_balance < debtLimit) && 
                                                                <Typography 
                                                                    sx={{
                                                                        color: '#eb530daa', 
                                                                        backgroundColor: '#ffebee',
                                                                        padding: '2px 8px',
                                                                        borderRadius: '4px',
                                                                        fontSize: '12px',
                                                                        fontWeight: 'medium', marginLeft:'6px'
                                                                    }}
                                                                >
                                                                    In debt
                                                                </Typography>
                                                            }
                                                        </Box>
                                                    </MenuItem>
                                            ))}
                                        </Select>
                                    </Grid2>
                                </Grid2>

                                <Grid2 container spacing={4} sx={{marginTop:'10%', marginBottom:'2%', justifyContent:'center'}}>
                                    <Grid2 item ><Button variant="contained" sx={{width:'120px', textTransform:'none', borderRadius:'8px', backgroundColor:'#0065ff', boxShadow:'none'}} onClick={saveReassign} disabled={reassignDriversData.length === 0}>Save</Button></Grid2>
                                    <Grid2 item ><Button onClick={cancelReassign} variant="contained" color="error"  sx={{width:'120px', textTransform:'none', borderRadius:'8px', boxShadow:'none'}}>Cancel</Button></Grid2>
                                </Grid2>
                            </Grid2>
                        </Box>
                    </Modal>

                </Grid2>
            )}

            {/* Shuttle  ------   (clientDemoFilter==2)  */}
            {clientDemoFilter==2 && (
                <Grid2 item container size={12} spacing={2}>
                    <Grid2 item size={4.2} sx={{ overflowY:'auto', maxHeight:'580px'}}>
                        {filteredMapViewData &&  filteredMapViewData.length>0 ? 
                            (filteredMapViewData.map((marker, index) => (
                                <Grid2 item className="mainBox" sx={{marginTop:'4%',cursor: 'pointer',
                                    border: selectedGrid===marker?.trip_details?.route_id ? "1px solid #83888E": 'none',
                                    boxShadow: selectedGrid===marker?.trip_details?.route_id ? "2" : 'none'
                                    }}
                                    key={index} onClick={() => handleShuttleGridClick(marker)}>
                                    <Grid2 item container>
                                        <Grid2 item size={9}>
                                            <Typography sx={{fontSize:'12px', color:'#83888E'}}>Route ID </Typography>
                                            <Typography sx={{fontSize:'16px'}}>ID: {marker?.trip_details?.route_id}</Typography>
                                        </Grid2>
                                        <Grid2 item size={3}>
                                            <Button
                                                variant="contained"
                                                style={{
                                                    backgroundColor: statusFilter==1 ? '#E7F8F2' : '#F9E9E9',
                                                    color: statusFilter==1 ? '#0DBA78' : '#D14545',
                                                    textTransform: 'none',
                                                    pointerEvents: 'none',
                                                    borderRadius: '6px',
                                                    minWidth: '60px',
                                                    border:'none',
                                                    boxShadow: 'none',
                                                    fontFamily: 'Poppins',
                                                    marginRight:'16px'
                                                }}
                                            >
                                                <FiberManualRecordIcon style={{ fontSize: '14px' }}/>
                                                {statusFilter==1 ? 'Active' : 'Inactive'}
                                            </Button>
                                        </Grid2>
                                    </Grid2>

                                    <Grid2 item sx={{backgroundColor:'#F9F9F9', display:'flex', alignItems:'center', padding:'4px 8px', borderRadius:'8px', marginTop:'2%', padding:'8px'}}>
                                        <Typography sx={{marginRight:'4%'}}>{marker?.trip_details?.pickup_stop_name}</Typography>
                                        <img src={connectAddress} alt="connect address" height="30%" width="30%" />
                                        <Typography sx={{marginLeft:'4%'}}>{marker?.trip_details?.drop_stop_name}</Typography>
                                    </Grid2>

                                    <Grid2 item container sx={{padding:'2%', marginTop:'2%', alignItems:'center'}}>
                                        <Grid2 item size={1}>
                                            <img src={pickupMarker} alt="pickup marker" width="20px" height="20px" />
                                        </Grid2>
                                        <Grid2 item size={11}>
                                            <Typography sx={{color:'#83888E', fontSize:'12px'}}>Starting Point</Typography>
                                            <Typography sx={{fontSize:'14px'}}>{marker?.trip_details?.pickup_stop_address}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <hr style={{border: 'none', borderTop: '2px dotted #D1D5DB', marginLeft:'36px'}} />

                                    <Grid2 item container sx={{padding:'2%', alignItems:'center'}}>
                                        <Grid2 item size={1}>
                                            <img src={dropMarker} alt="drop marker" width="20px" height="20px" />
                                        </Grid2>
                                        <Grid2 item size={11}>
                                            <Typography sx={{color:'#83888E', fontSize:'12px'}}>End Point</Typography>
                                            <Typography sx={{fontSize:'14px'}}>{marker?.trip_details?.drop_stop_address}</Typography>
                                        </Grid2>
                                    </Grid2>
                                    <hr style={{borderTop: '1px solid #D1D5DB'}} />

                                    <Grid2 item container sx={{marginTop:'2%'}}>
                                        <Grid2 item size={1} sx={{marginTop:'1%'}}>
                                            {marker.vehicle_info?.vehicle_type==1 && (
                                                <Grid2><img src={vehicleTypeCar} alt="taxi"/></Grid2>
                                            )}
                                            {marker.vehicle_info?.vehicle_type==2 && (
                                                <Grid2><img src={vehicleTypeBike} alt="bike"/></Grid2>
                                            )}
                                            {marker.vehicle_info?.vehicle_type==3 && (
                                                <Grid2><img src={vehicletypeAuto} alt="auto"/></Grid2>
                                            )}
                                            {marker.vehicle_info?.vehicle_type==4 && (
                                                <Grid2><img src={shuttleImg} alt="shuttle"/></Grid2>
                                            )}
                                        </Grid2>
                                        <Grid2 item size={5}>
                                            <Typography sx={{fontSize:'12px', color:'#83888E'}}>Economy</Typography>
                                            <Typography sx={{color:'#4E545D', fontSize:'14px'}}>{marker?.trip_details?.vehicle_number}</Typography>
                                        </Grid2>
                                        <Grid2 item size={5}>
                                            <Button sx={{border: '1px solid #0065ff', borderRadius:'10px', float:'right'}} onClick={() => moveToshuttleMapViewDetails(marker)}>
                                                <Typography sx={{textTransform:'none', color:'#0065ff'}}>View Details</Typography>
                                            </Button>
                                            
                                                {/* <Button sx={{border: '1px solid #0065ff', borderRadius:'10px', float:'right'}} 
                                                onClick={() => setOpenReassign(true)}
                                                >
                                                    <Typography sx={{textTransform:'none', color:'#0065ff'}}>Reassign</Typography>
                                                </Button>    */}
                                            
                                        </Grid2>
                                    </Grid2>
                                    {show_driver_gps_status == 1 && (
                                    <Grid2 container>
                                        <Grid2 item size={1}>
                                        </Grid2>
                                        <Grid2 item size={5}>
                                            <Typography sx={{fontSize:'12px', color:'#83888E'}}>GPS Status</Typography>
                                            {marker?.driver_info?.gps_status == 1 && (
                                                <Typography sx={{color:'#28ce49ff', fontSize:'14px'}}>Online</Typography>
                                            )}
                                            {marker?.driver_info?.gps_status == 0 && (
                                                <Typography sx={{color:'#fc4949ff', fontSize:'14px'}}>Offline</Typography>
                                            )}
                                        </Grid2>
                                        <Grid2 item size={6} sx={{float:'right'}}>
                                            <Typography sx={{fontSize:'12px', color:'#83888E'}}>Last Update </Typography>
                                            <Typography sx={{color:'#4E545D', fontSize:'14px'}}>
                                                {
                                                    marker.driver_info?.gps_updated_time ? (
                                                        <>
                                                        {formatDateTimeWithOffset(marker.driver_info.gps_updated_time)?.time12Hour}{" "}
                                                        On{" "}
                                                        {formatDateTimeWithOffset(marker.driver_info.gps_updated_time)?.date}
                                                        </>
                                                    ) : (
                                                        "--"
                                                    )
                                                    }
                                            </Typography>
                                        </Grid2>
                                    </Grid2>
                                    )}
                                </Grid2>    
                            )))
                            : (<div style={styles.errorBox}>
                                <p>No driver is online at this time.</p>
                            </div>)
                        }
                    </Grid2>

                    {!gridShuttleClickData && (
                        <Grid2 item size={7.5}>
                            <Grid2 item sx={{marginTop:'2%'}}>
                                {isLoaded && (
                                    <GoogleMap
                                        mapContainerStyle={containerStyleMain}
                                        center={initialcityCenter}
                                        zoom={12}
                                        onLoad={onLoad}
                                        onUnmount={onUnmount}
                                        >
                                        {mapViewData &&
                                            mapViewData.length > 0 &&
                                            mapViewData.map((marker, index) => (
                                            <Marker
                                                key={index}
                                                position={{
                                                lat: Number(marker.driver_details?.driver_current_latitude),
                                                lng: Number(marker.driver_details?.driver_current_longitude),
                                                }}
                                                title={marker.engagement_details?.engagement_id}
                                                icon={{
                                                url: mapPin,
                                                scaledSize: new window.google.maps.Size(30, 30),
                                                }}
                                            />
                                            ))}
                                        {heatMapData?.length > 0 && (
                                            <HeatmapLayer
                                            data={getHeatmapData(heatMapData)}
                                            options={{
                                                radius: 20,
                                                opacity: 1,
                                                dissipating: true,
                                                maxIntensity: 1,
                                                gradient: [
                                                'rgba(0, 255, 255, 0)',
                                                '#00FF00',
                                                '#FFFF00',
                                                'rgba(255, 0, 0, 0.75)',
                                                ],
                                            }}
                                            />
                                        )}
                                        </GoogleMap>
                                    
                                )}
                            </Grid2>
                        </Grid2>
                    )}

                    {gridShuttleClickData && (
                        <Grid2 item size={7.8}>
                            <Grid2 item sx={{marginTop:'2%'}}>
                                {isLoaded && (
                                    <GoogleMap 
                                        mapContainerStyle={containerStyleMain} 
                                        center={center}
                                        zoom={12} 
                                        onLoad={onLoad} 
                                        onUnmount={onUnmount}
                                        options={{
                                            zoomControl: true,
                                            mapTypeControl: false,
                                            streetViewControl: false,
                                            fullscreenControl: false
                                        }}
                                    >
                                        {showShuttleRoute && gridShuttleClickData?.trip_details?.route_details?.map((stop, index) => {
                                            const position = {
                                                lat: Number(stop.latitude),
                                                lng: Number(stop.longitude)
                                            };                                            
                                            let markerIcon;
                                            if (index === 0) {
                                                markerIcon = {
                                                    url: pickupMarker,
                                                    scaledSize: new window.google.maps.Size(30, 30)
                                                };
                                            } else if (index === gridShuttleClickData?.trip_details.route_details.length - 1) {
                                                markerIcon = {
                                                    url: dropMarker,
                                                    scaledSize: new window.google.maps.Size(30, 30)
                                                };
                                            } else {
                                                // For intermediate stops
                                                if (stop.is_skipped) {
                                                    markerIcon = {
                                                        url: yellowRouteMarker,
                                                        scaledSize: new window.google.maps.Size(30, 30)
                                                    };
                                                } else if (!stop.is_arrived && !stop.is_skipped) {
                                                    markerIcon = {
                                                        url: greyRouteMarker,
                                                        scaledSize: new window.google.maps.Size(30, 30)
                                                    };
                                                } else {
                                                    markerIcon = {
                                                        url: routeMarker,
                                                        scaledSize: new window.google.maps.Size(30, 30)
                                                    };
                                                }
                                            }

                                            return (
                                                <Marker 
                                                    key={`stop-${index}`}
                                                    position={position}
                                                    icon={markerIcon}
                                                    label={{
                                                        text: `${index + 1}`,
                                                        color: "#0065FF",
                                                        fontWeight: "bold",
                                                        fontSize: "12px"
                                                    }}
                                                    zIndex={index === 0 || index === gridShuttleClickData?.trip_details.route_details.length - 1 ? 2 : 1}
                                                />
                                            );
                                        })}
                                        

                                        {/* {animatedLatLng && (
                                        <Marker
                                            position={{
                                            lat: Number(animatedLatLng.lat),
                                            lng: Number(animatedLatLng.lng)
                                            }}
                                            icon={{
                                            url: mapVehicleICon,
                                            scaledSize: new window.google.maps.Size(100, 60)
                                            }}
                                            title="Live Vehicle Location"
                                        />
                                        )} */}
                                        {currentLatLng && (
                                            <Marker
                                                position={{ lat: Number(currentLatLng.lat), lng: Number(currentLatLng.lng) }}
                                                icon={{ url: mapVehicleICon, scaledSize: new window.google.maps.Size(100, 60) }}
                                                onLoad={(marker) => {
                                                setShuttleMarker(marker);
                                                marker.setPosition({
                                                    lat: Number(currentLatLng.lat),
                                                    lng: Number(currentLatLng.lng),
                                                });
                                                }}
                                            />
                                            )}


                                        {showShuttleRoute && gridShuttleClickData?.trip_details?.route_details?.length > 1 && (
                                            <Polyline
                                            path={bluePath}
                                                options={{
                                                    strokeColor: "#0065ff",
                                                    strokeOpacity: 1.0,
                                                    strokeWeight: 8,
                                                    zIndex: 1
                                                }}
                                            />

                                        )}
                                        {showShuttleRoute && gridShuttleClickData?.trip_details?.route_details?.length > 1 && (
                                            <Polyline
                                            path={greyPath}
                                                options={{
                                                    strokeColor: "#808080",
                                                    strokeOpacity: 1.0,
                                                    strokeWeight: 8,
                                                    zIndex: 0
                                                }}
                                            />

                                        )}
                                    </GoogleMap>
                                )}
                            </Grid2>
                        </Grid2>
                    )}
                </Grid2>
            )}

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>

                        <Modal
                open={openEndRideModal}
                onClose={() => setOpenEndRideModal(false)}
                aria-labelledby="end-ride-modal-title"
                aria-describedby="end-ride-modal-description"
            >
                <Box sx={style}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                        <WarningAmberIcon sx={{ fontSize: 50, color: 'warning.main' }} />
                        <Typography id="end-ride-modal-title" variant="h6" component="h2" sx={{ mt: 2, fontWeight: 'bold' }}>
                            End Ride Confirmation
                        </Typography>
                        <Typography id="end-ride-modal-description" sx={{ mt: 1, color: 'text.secondary' }}>
                            Are you sure you want to end this ride? This action cannot be undone.
                        </Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, gap: 2, width: '100%' }}>
                            <Button 
                                onClick={() => setOpenEndRideModal(false)} 
                                variant="outlined" 
                                sx={{ flex: 1 }}
                            >
                                Cancel
                            </Button>
                            <Button 
                                onClick={confirmEndRide} 
                                variant="contained" 
                                color="error" 
                                sx={{ flex: 1 }}
                            >
                                Yes
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            {ongoingRideCheck && (
                <Box
                    sx={{
                        position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
                        backgroundColor: "rgba(0, 0, 0, 0.5)", display: "flex", justifyContent: "center",
                        alignItems: "center", zIndex: 1300,
                    }}
                >
                    <Box
                        sx={{
                            backgroundColor: "#FFFFFF", borderRadius: "16px", width: "400px", padding: "24px",
                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.25)", textAlign: "center", display: "flex", flexDirection: "column", 
                        }}
                    >
                        <img src={CarDriver} height="210px" width="210px" alt="No drivers found" style={{alignSelf:'center'}}/>
    
                        <Typography sx={{ fontSize: "20px", color: "#000", marginBottom: "14px" }}>
                            {ongoingRideCheckMessage}
                        </Typography>
    
                        <Typography
                            onClick={handleCloseOngoingRideCheckModal}
                            sx={{
                                cursor: "pointer",color: "#0065FF",fontWeight: "500",fontSize: "18px",textDecoration: "none",
                                "&:hover": {textDecoration: "underline"},
                            }}
                        >
                            OK
                        </Typography>
                    </Box>
                </Box>
            )}

            <Dialog
                open={openTaxiCancelRide}
                onClose={() => setOpenTaxiCancelRide(false)}
                aria-labelledby="cancel-booking-dialog-title"
                aria-describedby="cancel-booking-dialog-description"
                PaperProps={{
                    style: {
                        borderRadius: '12px',
                        padding: '10px'
                    }
                }}
            >
                <DialogTitle id="cancel-booking-dialog-title" sx={{ fontWeight: 'bold' }}>
                    Confirm Cancellation
                </DialogTitle>
                <DialogContent>
                    <DialogContentText
                        id="cancel-booking-dialog-description"
                        sx={{ mb: 2 }}
                    >
                        Are you sure you want to cancel this ride with
                        <br />
                        Engagement ID{' '}
                        <Box component="span" sx={{ fontWeight: 600 }}>
                            {gridClickData?.engagement_details?.engagement_id}
                        </Box>
                        ?
                    </DialogContentText>

                    <hr sx={{ mb: 2 }} />

                    <Grid2 container direction="column" spacing={2}>
                        {((client_id == '273' && gridClickData?.engagement_details?.is_scheduled_request == 1) || 
                            (client_id != '273' && hide_fare_on_map_view_cancel == 0)) &&
                               <>
                                <Grid2 container alignItems="center" spacing={1}>
                                    <Grid2 sx={{ width: 180 }}>
                                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                            Trip Fare:
                                        </Typography>
                                    </Grid2>
                                    <Grid2 sx={{ flex: 1 }}>
                                        <TextField
                                            type="number" disabled
                                            variant="outlined"
                                            value={gridClickData?.payment_details?.trip_fare}
                                            fullWidth
                                            size="small"
                                        />
                                    </Grid2>
                                </Grid2>

                                {/* Refund Percentage */}
                                <Grid2 container alignItems="center" spacing={1}>
                                    <Grid2 sx={{ width: 180 }}>
                                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                            Refund Percentage:
                                        </Typography>
                                    </Grid2>
                                    <Grid2 sx={{ flex: 1 }}>
                                        <TextField
                                            type="number"
                                            variant="outlined"
                                            value={refundPercentage}
                                            onChange={(e) => setRefundPercentage(e.target.value)}
                                            fullWidth
                                            size="small"
                                        />
                                    </Grid2>
                                </Grid2>
                            </> 
                        }
                        {/* Cancellation Reason */}
                        <Grid2 container alignItems="flex-start" spacing={1}>
                            <Grid2 sx={{ width: 180 }}>
                                <Typography
                                    variant="body2"
                                    sx={{ fontWeight: 500, mt: 0.5 }}
                                >
                                    Cancellation Reason:
                                </Typography>
                            </Grid2>
                            <Grid2 sx={{ flex: 1 }}>
                                <TextField
                                    type="text"
                                    variant="outlined"
                                    value={cancelRideReason}
                                    onChange={(e) => setCancelRideReason(e.target.value)}
                                    fullWidth
                                    size="small"
                                    multiline
                                    minRows={2}
                                />
                            </Grid2>
                        </Grid2>
                    </Grid2>
                </DialogContent>
                <DialogActions sx={{paddingBottom:'20px', paddingRight:'20px'}}>
                    <Button 
                        onClick={() => setOpenTaxiCancelRide(false)} 
                        sx={{
                            color: '#6B7280', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            border: '1px solid #D1D5DB',
                            '&:hover': {
                                backgroundColor: '#F3F4F6',
                                borderColor: '#9CA3AF'
                            }
                        }}
                    >
                        No
                    </Button>
                    <Button 
                        onClick={() => {
                            handleCancelRide();
                        }} 
                        color="error"
                        variant="contained"
                        sx={{ 
                            backgroundColor: '#EF4444', 
                            borderRadius:'8px', 
                            textTransform:'none',
                            '&:hover': {
                                backgroundColor: '#DC2626'
                            }
                        }}
                        autoFocus
                    >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    )
}

export default MapView;